<template>
  <div class="dem-edi-pro-tab">
    <template v-if='statusGeral !== ""'>
      <RF-Status :cpntStatus='statusGeral' :cpntTamanho='5'></RF-Status>
    </template>

    <template v-else-if='statusGeral === ""'>
      <!-- SETA A TABELA DE DADOS -->
      <App-Tabela v-if="route !== ''"
      :cpntCheckbox="checkbox"
      :cpntColuna="colunas"
      :cpntLinha="linha"
      :cpntMostrarMper="cpntDemandaFlag === ''"
      :cpntApiTabPer="cpntDemandaFlag === '' ? tabper : ''"
      :cpntApiTabPerFiltros="false"
      :cpntApiTabPerRpp="null"
      :cpntApiTabPerOrder="null"
      :cpntBotaoExcluir="botaoExcluir"
      :cpntBotaoEditar="botaoEditar"
      :cpntBotaoCopiar="botaoCopiar"
      :cpntSalvarEdicao="demEdiProTabEditar"
      :cpntSetarValores="demEdiProTabSetarLinhas"
      :cpntBotaoModificar="botaoModificar"
      :cpntBotaoModificaCancela="botaoModificaCancela"
      :cpntApiRouter="route"
      :cpntApiMethods="method"
      :cpntApiEstruturaQueryGet="estruturaQueryGet"
      :cpntApiField="field"
      :cpntApiFieldVirtual="fieldVir"
      :cpntApiWhere="where"
      :cpntApiOrder="order"
      @TABELA_MARCAR_CHECKBOX='demEdiProTabMarcarCheckbox'
      ref="tabela">
        <!-- SETA A FRASE SOBRE A TABELA -->
        <template slot="titulo">
          <!-- VERIFICA SE TEM QUE MOSTRAR O BOTÃO REINICIALIZAR -->
          <App-Button :key="'botaoReinicializar--' + botaoReinicializar" v-if="botaoReinicializar !== undefined" :disabled="botaoReinicializar === 'carregando'" :cpntClass="'btn btn-default btn-sm'" title="Clique aqui para reinicializar." :cpntIcone="'historico'" @onClick="() => { botaoReinicializar() }"></App-Button>

          <!-- SETA O BOTÃO PARA CARREGAR OS CUSTOS --> 
          <App-Button :key="'botaoCusto--' + botaoCusto" v-if="cpntDemanda === 'venda' && botaoCusto !== undefined" :disabled="botaoCusto === 'carregando'" :cpntClass="'btn btn-default btn-sm'" title="Clique aqui para ver os custos dos produtos." :cpntIcone="'fa fa-file-invoice-dollar'" @onClick="() => { botaoCusto() }"></App-Button>

          <!-- SETA O TITULO DA TELA -->
          <div class="dem-edi-pro-tab-titulo">|
            <template v-if="cpntDemanda === 'venda' && $store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 17 ], null, [ 10 ], null, [ 40 ], null, false) === true">
              Total Produtos R$ {{ demEdiProTabValorLiquidoProduto }} - 
            </template>
            <template v-else-if="cpntDemanda === 'compra' && $store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 5 ], null, [ 11 ], null, [ 45 ], null, false) === true">
              Total Produtos R$ {{ demEdiProTabValorLiquidoProduto }} - 
            </template>
            {{ cpntDemandaTotal.produto.item }} item(ns)
          </div>

          <div class="dem-edi-pro-tab-itens--etiqueta" v-if="[ 'compra' ].indexOf(cpntDemanda) !== -1 && linha.length >= 1">
            <App-Button :cpntClass="'btn btn-default btn-sm'" title="Clique aqui para gerar a etiqueta" @onClick="() => { demEdiProTabAbrirEtiqueta() }">
              Gerar Etiquetas
            </App-Button>
          </div>
        </template>

        <!-- MOSTRA A COLUNA DE DETALHE DO PRODUTO -->
        <!-- <template v-slot:col_detalhe="{ linha, mostrarLinhaAdi, linhaAdi }">
          <div @click="() => { demEdiProTabProdutoOnChangeLinhaAdicional(linha) }" :key="'mostrar-linha-adicional' + mostrarLinhaAdi">
            <svg v-if="linhaAdi.indexOf(linha.id) === -1" class="ocultar_mostrar fa fa-eye-slash"></svg>
            <svg v-else class="ocultar_mostrar fa fa-eye"></svg>
          </div>
        </template> -->

        <!-- pco_status -->
        <template v-slot:th_id_pco_item>
          <!-- SETA O TITULO DA COLUNA -->
          <!-- <div>Status do processo</div> -->
          Status do processo

          <!-- COLOCA O BOTÃO -->
          <App-Button v-if="linha.length >= 1" :cpntIcone="'editar'" :cpntClass="'btn btn-warning btn-sm'" @onClick="demEdiProTabAbrirAlteracaoProcesso"></App-Button>
        </template>

        <!-- COLOCA O CODIGO -->
        <template v-slot:col_id_pro_codigo="{ linha }">
          <!-- COLOCA O CODIGO -->
          <span v-html="linha.id_pro_codigo"></span>

          <!-- COLOCA O BOTÃO DE HISTORICO -->
          <template v-if="[ 'venda', 'compra' ].indexOf(cpntDemanda) !== -1">
            <br/>
            <button @click="demEdiProTabAbrirHistorico(linha.id_pro)" style="padding: 2px 3px;" class="btn btn-default btn-sm" title="Clique aqui para ver o histórico deste produto.">
              <svg class="fas fa-chart-line"></svg>
            </button>
          </template>
        </template>

        <!-- COLUNA NOME -->
        <template v-slot:col_id_pro_nome="{ linha, indexL }">
          <!-- SETA O BOTÃO DE CONSUMO -->
          <!-- <App-Button v-if="linha.fabricado === 's'" :cpntClass="[ 'btn', 'btn-default', 'btn-sm', 'fabricacao' ]" @onClick="() => { proFabTabSetarRelatorioConsumo(linha.id) }">               -->
          <!-- <App-Button v-if="linha.fabricado === 's'" :cpntClass="[ 'btn', 'btn-default', 'btn-sm', 'fabricacao' ]" @onClick="() => { proFabTabSetarRelatorioConsumo(linha) }">              
            <App-Icone :cpntTipo="'insumo'"></App-Icone>
          </App-Button> -->

          <button class="btn btn-default btn-sm app-cadastro-link" :class="($store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 6 ], null, [ 12 ], null, [ 78 ], 'or', false) === false) ? 'app-cadastro-link-disabled' : ''" @click="demEdiProTabProdutoOnClick(indexL)">
            <!-- APRESENTA O NOME DO PRODUTO -->
            <span v-html="linha.id_pro_nome"></span>

            <!-- VERIFICA SE O PRODUTO ESTÁ EXCLUIDO -->
            <span v-if="linha.id_pro_status !== '1'"><b>[Excluído]</b></span>
          </button>
        </template>

        <!-- COLUNA DE VALORES -->
        <template v-slot:valor="{ linha, valor, indexCV }" >
          <span v-html="demEdiProTabFormatarValor(valor, indexCV)"></span>

          <!-- APRESENTA O SIMBOLO DE DIFERNEÇA NO CASO -->
          <span :set="indexDiff = indexCV.replace('p_', '')" v-if="[ '', null, undefined ].indexOf(linha.virtual_check_caso) === -1 && linha.virtual_check_caso.qtde >= 1">
            <template v-if="[ '', null, undefined ].indexOf(linha.virtual_check_caso.diff[indexDiff]) === -1">
              <App-Icone :cpntTipo="'alerta-amarelo'" :cpntExplica="{ mensagem: 'Foi encontrado diferença neste campo: <br/><br/>' + linha.virtual_check_caso.diff[indexDiff] }"></App-Icone>
            </template>
          </span>
        </template>


        <template v-slot:col_valor_des="{ linha, indexCV }" >
          <!-- {{ linha.valor_des_fixo }} -->
          <span :title="demEdiProTabPorcentagemDescontoTitulo(linha)" v-html="demEdiProTabFormatarValor(linha.valor_des_fixo, indexCV)"></span>

          <!-- APRESENTA O SIMBOLO DE DIFERNEÇA NO CASO -->
          <span :set="indexDiff = indexCV.replace('p_', '')" v-if="[ '', null, undefined ].indexOf(linha.virtual_check_caso) === -1 && linha.virtual_check_caso.qtde >= 1">
            <template v-if="[ '', null, undefined ].indexOf(linha.virtual_check_caso.diff[indexDiff]) === -1">
              <App-Icone :cpntTipo="'alerta-amarelo'" :cpntExplica="{ mensagem: 'Foi encontrado diferença neste campo: <br/><br/>' + linha.virtual_check_caso.diff[indexDiff] }"></App-Icone>
            </template>
          </span>

          <span style="font-size: calc(100% - 2px);">
            <br/>
            <span :title="demEdiProTabPorcentagemDescontoTitulo(linha)">{{ demEdiProTabPorcentagemDescontoValor(linha) }}%</span>
          </span>
        </template>

        <!-- COLUNA DE VALORES -->
        <template v-slot:col_caso="{ linha, indexCV, indexL }" >
          <template v-if="[ '', null, undefined ].indexOf($store.state.licenca.uf) !== -1">
            <span style="color: red;">OPS! Selecione um Estado para a SUA empresa clicando em Configurações (engrenagem) -> Meu Cadastro.</span>
          </template>
          <template v-else-if="cpntIdConPessoa !== 'e' && [ '', null, undefined ].indexOf(cpntIdConUF) !== -1 && cpntPDocTp === 'NFe'">
            <span style="color: red;">OPS! Insira o Estado no cadastro do seu Contato.</span>
          </template>
          <template v-else-if="[ '', null, undefined ].indexOf(linha.id_pro_ncm) !== -1">
            <span style="color: red;" @click='(event) => { demEdiProTabAcaoEditarCampo(event, indexL, "id_pro_ncm") }'>OPS! Cadastre primeiramente o NCM deste produto no campo ao lado.</span>
          </template>
          <template v-else-if="[ '', null, undefined ].indexOf(linha._p_id_sf2_nome) === -1">
            <!-- SETA O NOME DO CASO SELECIONADO -->
            <div>
              <!-- SETA O NOME DO CASO -->
              <span v-html="linha._p_id_sf2_nome"></span>

              <!-- SETA O STATUS DE EXCLUIDO DO CAMPO -->
              <span v-if="linha.p_id_sf2_status !== '1'" style="font-size: calc(100% - 3px);" ><b> [Excluído]</b></span>

              <!-- SETA A EXPLICAÇÃO DO CAMPO -->
              <App-Explica :cpntTitle="linha._p_id_sf2_title"></App-Explica>
            </div>

            <!-- COLOCA O BOTÃO DE DETALHES DO CASO -->
            <!-- <App-Button v-if="[ 'dev_cliente', 'compra' ].indexOf(cpntDemanda) === -1"
            :cpntIcone='"mais"'
            :cpntClass='[ "btn", "btn-default" ]'
            @onClick='() => { demEdiProTabSetarEditar(linha) }'
            ></App-Button> -->

            <!-- APRESENTA O SIMBOLO DE DIFERNEÇA NO CASO -->
            <App-Button v-if="[ '', null, undefined ].indexOf(linha.virtual_check_caso) === -1 && linha.virtual_check_caso.qtde >= 1" class="diff" @onClick="demEdiProTabAcaoTriangulo(indexCV, linha)">
              <App-Icone :cpntTipo="'alerta-amarelo'" :cpntExplica="linha.virtual_check_caso.explica"></App-Icone>
            </App-Button>
          </template>
          <template v-else>
            <App-Button class="diff" @onClick="(id, event) => { demEdiProTabAcaoEditarCampo(event, indexL, 'caso') }">
              <App-Icone :data-time='time' :cpntTipo='"erro-vermelho"' :cpntExplica="{ mensagem: 'Nenhum caso encontrado.', posicaoMy: 'top right',   posicaoAt: 'bottom left' }" style="cursor: pointer;"></App-Icone>
            </App-Button>
          </template>
        </template>

        <!-- COLUNA DE INFORMAÇÕES -->
        <template v-slot:col_p_com_ind="{ valor }" >
          <span v-html="valor === '1' ? 'Sim' : 'Não'"></span>
        </template>

        <!-- COLUNA DE INFORMAÇÕES -->
        <template v-slot:col_custo="{ linha, indexCV }">
          <!-- ({{ linha.virtual_custo_historico }}) -->
          <!-- SETA O VALOR DO CUSTO -->
          <span v-html="demEdiProTabFormatarValor((Number(linha.virtual_custo_historico.custo_total) * 100).toFixed(0), indexCV)"></span>
          
          <!-- SETA O BOTÃO PARA DETALHAMENTO DO CUSTO -->
          <App-Button :data-time="time" style="margin: 2px; padding: 2px 3px;" :cpntIcone="'info'" title="Clique aqui para as informações do custo" @onClick="() => { detalheCusto = linha } " ref="btDialogRel"></App-Button>
        </template>

        <!-- COLUNA DE INFORMAÇÕES -->
        <template v-slot:info="{ linha, valor, indexCV }" >
          <span v-html="valor" :title="demEdiProTabMontarTitle(indexCV, linha)"></span>

          <!-- APRESENTA O SIMBOLO DE DIFERNEÇA NO CASO -->
          <span :set="indexDiff = indexCV.replace('p_', '')" v-if="[ '', null, undefined ].indexOf(linha.virtual_check_caso) === -1 && linha.virtual_check_caso.qtde >= 1">
            <App-Button v-if="[ '', null, undefined ].indexOf(linha.virtual_check_caso.diff[indexDiff]) === -1" class="diff" @onClick="demEdiProTabAcaoTriangulo(indexCV, linha)">
              <App-Icone :cpntTipo="'alerta-amarelo'" :cpntExplica="{ mensagem: 'Foi encontrado diferença neste campo: <br/><br/>' + linha.virtual_check_caso.diff[indexDiff].ven_pro + ' => ' + linha.virtual_check_caso.diff[indexDiff].sit_fiscal }"></App-Icone>
            </App-Button>
          </span>
        </template>

        <!-- SETA A DATA E HORA DA ULTIMA ATUALIZAÇÃO -->
        <template v-slot:col_id_pco_item="{ linha }">
          <table v-if="linha.status_processo !== null" @click="() => { demEdiProTabAbrirControleProcesso(linha) }">
            <tr>
              <td :style="'color: ' + linha.status_processo.cor_letra + '; background: ' + linha.status_processo.cor_fundo + ';'">
                <span v-html="linha.status_processo.nome"></span>
              </td>
            </tr>
          </table>

          <!-- SETA O VALOR DA COLUNA -->
          <div v-else>---</div>
        </template>

        <!-- COLUNA SOBRE -->
        <template v-slot:col_p_icms_bc_p_r_c="{ linha, indexCV }">
          <span v-if="[ '', null, undefined ].indexOf(linha.virtual_p_icms_bc_p_r_c_desc) === -1" v-html="linha.virtual_p_icms_bc_p_r_c_desc"></span>
          <span v-else-if="[ '', null, undefined ].indexOf(linha.p_icms_bc_p_r_c) === -1" v-html="linha.p_icms_bc_p_r_c"></span>

          <!-- APRESENTA O SIMBOLO DE DIFERNEÇA NO CASO -->
          <span :set="indexDiff = indexCV.replace('p_', '')" v-if="[ '', null, undefined ].indexOf(linha.virtual_check_caso) === -1 && linha.virtual_check_caso.qtde >= 1">
            <template v-if="[ '', null, undefined ].indexOf(linha.virtual_check_caso.diff[indexDiff]) === -1">
              <App-Icone :cpntTipo="'alerta-amarelo'" :cpntExplica="{ mensagem: 'Foi encontrado diferença neste campo: <br/><br/>' + linha.virtual_check_caso.diff[indexDiff] }"></App-Icone>
            </template>
          </span>
        </template>

        <!-- COLUNA DE COMISSIONADO -->
        <template v-slot:col_cms_com_id="{ linha }">
          <div class="btn btn-default btn-sm app-cadastro-link" @click="demEdiProTabVendedorOnClick(linha.id)">
            <template v-if="[ '', null, undefined ].indexOf(linha.cms_com_id) === -1">
              <!-- SETA O NOME DO VENDEDOR -->
              <span v-html="demEdiProTabMontarNomeVendedor(linha)"></span>
              
              <!-- SETA A EXPLICAÇÃO DO VENDEDOR -->
              <App-Explica :data-time='time' :key="'cms_con--' + linha.cms_com_id + '--cms_val--' + linha.cms_valor"
                :cpntId='"dem-pro-tab-exp-vendedor--" + linha.id'
                :cpntTitle='demEdiProTabMontarExplicaVendedor(linha)'
              ></App-Explica>
            </template>
            <template v-else>
              ---
            </template>
          </div>
        </template>

        <template v-slot:editar_celula="vetor">
          <span v-if="campoEditar[vetor.chave] !== null" :data-time="time">
            <!-- ({{ campoEditar[vetor.chave] }})
            ({{ vetor.hash }}) -->
            <!-- CHAMA A FUNÇÃO PARA CARREGAR OS DADOS -->
            <template v-if="campoEditar[vetor.chave] === undefined || campoEditar[vetor.chave].tipo === '' || campoEditar[vetor.chave].hash !== vetor.hash">
              <!-- EXECUTA A FUNÇÃO PARA MONTAR O CAMPO -->
              {{ demEdiProTabIniciarEdicaoCampo(vetor) }}

              <!-- SETA O STATUS DO CAMPO -->
              <App-Status-2 :cpntStatus='"carregando"' ></App-Status-2>
            </template>

            <div :data-time="time" v-else-if='[ "valor_des" ].indexOf(vetor.indexCV) !== -1' class="porcentagem-input">
              <App-Select :data-time="time"
              :cpntStatus='campoEditar[vetor.chave].status'
              :cpntId='campoEditar[vetor.chave].id + "--p"'
              :cpntTabIndex='campoEditar[vetor.chave].tabIndex'
              :cpntNome='campoEditar[vetor.chave].nome'
              :cpntValue='campoEditar[vetor.chave].valueS'
              :cpntMensagem='campoEditar[vetor.chave].mensagem'
              :cpntDisabled='campoEditar[vetor.chave].disabled'
              :cpntMostrar='campoEditar[vetor.chave].mostrar'
              :cpntExplica='campoEditar[vetor.chave].explica'
              :cpntPlaceholder='campoEditar[vetor.chave].placeholder'
              :cpntValueRef='campoEditar[vetor.chave].valueRef'
              :cpntRouter='campoEditar[vetor.chave].router'
              :cpntField='campoEditar[vetor.chave].field'
              :cpntWhere='campoEditar[vetor.chave].where'
              :cpntAddButForm='campoEditar[vetor.chave].addButForm'
              :cpntKeyMostra='campoEditar[vetor.chave].keyMostra'
              :cpntTipoOrder='campoEditar[vetor.chave].tipoOrder'
              :cpntOrder='campoEditar[vetor.chave].order'
              :cpntOptions='campoEditar[vetor.chave].options'
              :cpntKeyValue='campoEditar[vetor.chave].keyValue'
              :cpntSearchMinimo='campoEditar[vetor.chave].searchMinimo'
              :cpntMask='campoEditar[vetor.chave].mask'
              :cpntNewOption='campoEditar[vetor.chave].newOption'
              :cpntOptionInicialNome='campoEditar[vetor.chave].optionInicialNome'

              :cpntOnBuscarOptions='campoEditar[vetor.chave].onBuscarOptions'
              :cpntOnChange='campoEditar[vetor.chave].onChange'
              :cpntOnBlur='campoEditar[vetor.chave].onBlur'
              :cpntOnRealizaBusca='campoEditar[vetor.chave].onRealizaBusca'
              :cpntOnKeyPressEnter='campoEditar[vetor.chave].onKeyPressEnter'
              :ref="campoEditar[vetor.chave].id"
              ></App-Select>

              <App-Input :data-time="time"
              :cpntStatus='campoEditar[vetor.chave].status'
              :cpntId='campoEditar[vetor.chave].id + "--v"'
              :cpntTabIndex='campoEditar[vetor.chave].tabIndex'
              :cpntNome='campoEditar[vetor.chave].nome'
              :cpntValue='campoEditar[vetor.chave].value'
              :cpntMensagem='campoEditar[vetor.chave].mensagem'
              :cpntDisabled='campoEditar[vetor.chave].disabled'
              :cpntMostrar='campoEditar[vetor.chave].mostrar'
              :cpntExplica='campoEditar[vetor.chave].explica'
              :cpntPlaceholder='campoEditar[vetor.chave].placeholder'
              :cpntValueRef='campoEditar[vetor.chave].valueRef'
              :cpntRouter='campoEditar[vetor.chave].router'
              :cpntField='campoEditar[vetor.chave].field'
              :cpntWhere='campoEditar[vetor.chave].where'
              :cpntAddButForm='campoEditar[vetor.chave].addButForm'
              :cpntKeyMostra='campoEditar[vetor.chave].keyMostra'
              :cpntTipoOrder='campoEditar[vetor.chave].tipoOrder'
              :cpntOrder='campoEditar[vetor.chave].order'
              :cpntOptions='campoEditar[vetor.chave].options'
              :cpntKeyValue='campoEditar[vetor.chave].keyValue'
              :cpntSearchMinimo='campoEditar[vetor.chave].searchMinimo'
              :cpntMask='((typeof campoEditar[vetor.chave].valueS === "string" ? campoEditar[vetor.chave].valueS : campoEditar[vetor.chave].valueS.id) === "%" ? "valorDecimalNovo" : "valorMoeda")'

              :cpntOnChange='campoEditar[vetor.chave].onChange'
              :cpntOnBlur='campoEditar[vetor.chave].onBlur'
              :cpntOnRealizaBusca='campoEditar[vetor.chave].onRealizaBusca'
              :cpntOnKeyPressEnter='vetor.salvar'
              :ref="campoEditar[vetor.chave].id"
              ></App-Input>
            </div>

            <!-- SETA O CAMPO INPUT -->
            <template v-else-if='campoEditar[vetor.chave].tipo === "input"'>
              <App-Input :data-time="time"
                :cpntStatus='campoEditar[vetor.chave].status'
                :cpntId='campoEditar[vetor.chave].id'
                :cpntTabIndex='campoEditar[vetor.chave].tabIndex'
                :cpntNome='campoEditar[vetor.chave].nome'
                :cpntValue='campoEditar[vetor.chave].value'
                :cpntMensagem='campoEditar[vetor.chave].mensagem'
                :cpntDisabled='campoEditar[vetor.chave].disabled'
                :cpntMostrar='campoEditar[vetor.chave].mostrar'
                :cpntExplica='campoEditar[vetor.chave].explica'
                :cpntPlaceholder='campoEditar[vetor.chave].placeholder'
                :cpntValueRef='campoEditar[vetor.chave].valueRef'
                :cpntRouter='campoEditar[vetor.chave].router'
                :cpntField='campoEditar[vetor.chave].field'
                :cpntWhere='campoEditar[vetor.chave].where'
                :cpntAddButForm='campoEditar[vetor.chave].addButForm'
                :cpntKeyMostra='campoEditar[vetor.chave].keyMostra'
                :cpntTipoOrder='campoEditar[vetor.chave].tipoOrder'
                :cpntOrder='campoEditar[vetor.chave].order'
                :cpntOptions='campoEditar[vetor.chave].options'
                :cpntKeyValue='campoEditar[vetor.chave].keyValue'
                :cpntSearchMinimo='campoEditar[vetor.chave].searchMinimo'
                :cpntMask='campoEditar[vetor.chave].mask'

                :cpntOnChange='campoEditar[vetor.chave].onChange'
                :cpntOnBlur='campoEditar[vetor.chave].onBlur'
                :cpntOnRealizaBusca='campoEditar[vetor.chave].onRealizaBusca'
                :cpntOnKeyPressEnter='vetor.salvar'
                :ref="campoEditar[vetor.chave].id"
              ></App-Input>
            </template>

            <template v-else-if='campoEditar[vetor.chave].tipo === "select"'>
              <App-Select :data-time="time" 
                :cpntStatus='campoEditar[vetor.chave].status'
                :cpntId='campoEditar[vetor.chave].id'
                :cpntTabIndex='campoEditar[vetor.chave].tabIndex'
                :cpntNome='campoEditar[vetor.chave].nome'
                :cpntValue='campoEditar[vetor.chave].value'
                :cpntMensagem='campoEditar[vetor.chave].mensagem'
                :cpntDisabled='campoEditar[vetor.chave].disabled'
                :cpntMostrar='campoEditar[vetor.chave].mostrar'
                :cpntExplica='campoEditar[vetor.chave].explica'
                :cpntPlaceholder='campoEditar[vetor.chave].placeholder'
                :cpntValueRef='campoEditar[vetor.chave].valueRef'
                :cpntRouter='campoEditar[vetor.chave].router'
                :cpntField='campoEditar[vetor.chave].field'
                :cpntWhere='campoEditar[vetor.chave].where'
                :cpntAddButForm='campoEditar[vetor.chave].addButForm'
                :cpntKeyMostra='campoEditar[vetor.chave].keyMostra'
                :cpntTipoOrder='campoEditar[vetor.chave].tipoOrder'
                :cpntOrder='campoEditar[vetor.chave].order'
                :cpntOptions='campoEditar[vetor.chave].options'
                :cpntKeyValue='campoEditar[vetor.chave].keyValue'
                :cpntSearchMinimo='campoEditar[vetor.chave].searchMinimo'
                :cpntMask='campoEditar[vetor.chave].mask'
                :cpntNewOption='campoEditar[vetor.chave].newOption'
                :cpntOptionInicialNome='campoEditar[vetor.chave].optionInicialNome'

                :cpntOnBuscarOptions='campoEditar[vetor.chave].onBuscarOptions'
                :cpntOnChange='campoEditar[vetor.chave].onChange'
                :cpntOnBlur='campoEditar[vetor.chave].onBlur'
                :cpntOnRealizaBusca='campoEditar[vetor.chave].onRealizaBusca'
                :cpntOnKeyPressEnter='campoEditar[vetor.chave].onKeyPressEnter'
                :ref="campoEditar[vetor.chave].id"
              ></App-Select>
            </template>

            <span :data-time="time" v-else style="color: red; font-weight: bold;">ERRO AQUI</span>
          </span>
        </template>

        <!-- LINHA ADICIONAL -->
        <template v-slot:linha_adicional="{ linha }">
          <Demanda-Editar-Produtos-Tabela-Item-2
          :cpntDemanda="cpntDemanda"
          :cpntDemandaId="cpntDemandaId"
          :cpntPDocTp="cpntPDocTp"
          :cpntItemId="linha.id"

          @DEMANDA_ATUALIZAR_DADOS='demEdiProTabAtualizarDados'
          :ref="'editar_linha_' + linha.id"
          ></Demanda-Editar-Produtos-Tabela-Item-2>
        </template>
      </App-Tabela>
      
      <!-- CARREGA OS DETALHES DOS CAMPOS -->
      <Demanda-Editar-Produtos-Tabela-Item v-if="editar !== null"
      :cpntDemanda="cpntDemanda"
      :cpntDemandaId="cpntDemandaId"
      :cpntItemId="editar.id"
      :cpntDados="editar"
      :cpntEditar="cpntFinStatus !== 's' && cpntPDocNFEmitida === false"
      :cpntPDocNFEmitida="cpntPDocNFEmitida"
      :cpntPDocTp="cpntPDocTp"
      :cpntIdCon="cpntIdCon"
      :cpntIdConUF="cpntIdConUF"
      :cpntFecharFormulario="demEdiProTabEditarItemFechar"
      @DEMANDA_PRODUTO_TABELA_UPDATE='demEdiProTabBuscarLinhas'
      ></Demanda-Editar-Produtos-Tabela-Item>
    </template>

    <App-Produto-Sit-Fiscal-Formulario v-if="dialog === null && sit_fiscal !== null"
    :cpntId="sit_fiscal.id"
    :cpntDemanda="cpntDemanda"
    :cpntProdutos="sit_fiscal.id_pros"
    :cpntNcms="sit_fiscal.ncms"
    :cpntDiff="sit_fiscal.dados"
    :cpntIdConUF="([ '', null, undefined ].indexOf(this.cpntIdConUF) === -1 ? this.cpntIdConUF : this.$store.state.licenca.uf)"
    :cpntIdConPessoa="cpntIdConPessoa"
    :cpntIsOpenDemanda="true"
    :cpntFecharFormulario="sit_fiscal.fechar"
    ></App-Produto-Sit-Fiscal-Formulario>

    <!-- NOVO_OU_ALTERAR_SIT_FISCAL -->
    <RF-Dialog v-if="dialog === 'NOVO_OU_ALTERAR_SIT_FISCAL'"
    :cpntLargura='"500px"'
    :cpntOnFecharDialog='() => { dialog = null; sit_fiscal = null; }'>
    <template slot="conteudo">
      <div class="dem-edi-pro-tab-acao-sit-fiscal">
        <!-- APRESENTA A MENSAGEM -->
        Como deseja salvar a(s) diferenças em Produtos -> Situações Fiscais?.
        <br/>

        <!-- SETA O BOTÃO DE NOVA -->
        <App-Button :cpntClass="[ 'btn', 'btn-primary', 'btn-sm' ]" @onClick="() => { demEdiProTabAbrirSitFiscalEscolha('NOVO') }" :cpntExplica="{ mensagem: 'Cria uma nova situação fiscal e atualiza este item.' }">NOVA</App-Button>

        <!-- SETA O BOTÃO DE ATUALIZAR -->
        <App-Button :cpntClass="[ 'btn', 'btn-warning', 'btn-sm' ]" @onClick="() => { demEdiProTabAbrirSitFiscalEscolha('EDITAR') }" :cpntExplica="{ mensagem: 'Atualiza a situação fiscal com os mesmos parâmetros deste item.' }">ATUALIZAR</App-Button>

        <!-- SETA O BOTÃO DE REINICIALIZAR -->
        <App-Button :cpntClass="[ 'btn', 'btn-default', 'btn-sm' ]" @onClick="() => { demEdiProTabAbrirSitFiscalEscolha('REINICIALIZAR') }" :cpntExplica="{ mensagem: 'Reinicia o item deixando igual a situação fiscal original.' }">REINICIALIZAR</App-Button>
      </div>
    </template>
    </RF-Dialog>
    
    <!-- SETA A TELA PARA EDITAR VARIOS PROCESSOS AO MESMO TEMPO -->
    <App-Controle-Processo-Editar-Varios v-if="pco_editar !== null && pco_editar.length >= 1"
    :cpntIds="pco_editar"
    :cpntTipo="'produto'"
    :cpntFecharFormulario="demEdiProTabFecharAlteracaoProcesso"
    ></App-Controle-Processo-Editar-Varios>

    <!-- SETA A TELA DE CONSUMO DE FABRICAÇÃO -->
    <!-- <App-Produto-Fabricado-Consumo v-if="consumo !== null"
    :cpntDados="consumo"
    :cpntFecharFormulario="() => { proFabTabSetarRelatorioConsumo(null) }"
    ></App-Produto-Fabricado-Consumo> -->

    <App-Relatorio-Detalhe-Custo v-if="detalheCusto !== null"
    :cpntDetalhe="detalheCusto"
    :cpntFecharFormulario="() => { detalheCusto = null }"
    ></App-Relatorio-Detalhe-Custo>
  </div>
</template>

<style scoped>
  .dem-edi-pro-tab {
    margin-top: 10px;
    margin-bottom: 10px;
    max-width: 100%;
    overflow: auto;
  }
  .dem-edi-pro-tab-titulo {
    font-weight: bold;
    display: inline-block;
    padding: 10px 0px;
  }
  .dem-edi-pro-tab-itens--etiqueta {
    float: right;
  }
    .dem-edi-pro-tab-itens--etiqueta > button {
      padding: 2px 8px;
      margin-top: 5px;
    }

  .dem-edi-pro-tab-acao-sit-fiscal {
    text-align: center;
    padding-top: 5px;
  }
    .dem-edi-pro-tab-acao-sit-fiscal > button {
      width: 120px;
      margin: 15px 5px;
    }
</style>

<style>
  .dem-edi-pro-tab > table > thead > tr > .col_id_pco_item {
    width: 135px;
  }
    .dem-edi-pro-tab > table > thead > tr > .col_id_pco_item > button {
      width: 25px;
      height: 25px;
      padding: 0px;
      margin-left: 5px;
    }
      .dem-edi-pro-tab > table > thead > tr > .col_id_pco_item > button > span > img {
        width: 14px;
        height: 14px;
      }
  .dem-edi-pro-tab > table > tbody > tr > .col_id_pro_nome > div > span > button.fabricacao {
    margin: 0px;
    width: 28px;
    height: 23px;
    padding: 0px;
    display: inline-block;
  }
  .dem-edi-pro-tab > table > tbody > tr > .col_id_pro_nome {
    max-width: 280px;
  }
  .dem-edi-pro-tab > table > tbody > tr > .col_id_pro_nome > div > span > button.fabricacao ~ button {
    width: calc(100% - 28px - 2px);
    margin-left: 2px;
    display: inline-block;
  }
  .dem-edi-pro-tab > table > tbody > tr > .col_caso {
    background: #f4f1c3;
    width: 100px;
    min-width: 100px;
    max-width: 100px;
  }
    .dem-edi-pro-tab > table > tbody > tr > .col_caso,
    .dem-edi-pro-tab > table > tbody > tr > .col_caso > div,
    .dem-edi-pro-tab > table > tbody > tr > .col_caso > div > span > div {
      text-align: center;
    }
    .dem-edi-pro-tab > table > tbody > tr > .col_caso > div > span > div {
      width: 100%;
      max-width: 90px;
      /* white-space: nowrap; */
      /* text-overflow: ellipsis; */
      overflow: hidden;
    }
    
      .dem-edi-pro-tab > table > tbody > tr > .col_caso > div > span > div > img {
        opacity: 0.75;
      }
    .dem-edi-pro-tab > table > tbody > tr > .col_caso.cpnt-tabela-editar {
      width: 155px;
      min-width: 155px;
      max-width: 155px;
    }
    .dem-edi-pro-tab > table > tbody > tr > .col_caso.cpnt-tabela-editar > div,
    .dem-edi-pro-tab > table > tbody > tr > .col_caso > div > span > span > div.cpnt-app-select {
      width: 150px;
      min-width: 150px;
      max-width: 150px;
    }
      .dem-edi-pro-tab > table > tbody > tr > .col_caso > div > span > button:not(.diff) {
        /* margin-left: 5px; */
        width: 25px;
        height: 22px;
        padding: 0px;
      }
        .dem-edi-pro-tab > table > tbody > tr > .col_caso > div > span > button:not(.diff) > span > img {
          width: 15px;
          height: 15px;
        }

      
  .dem-edi-pro-tab > table > tbody > tr > .col_cms_com_id > div {
    text-align: center !important;
  }
    .dem-edi-pro-tab > table > tbody > tr > .col_cms_com_id > div > img {
      vertical-align: -1px;
    }
  
  .dem-edi-pro-tab > table > tbody > tr > .col_cms_com_id,
  .dem-edi-pro-tab > table > tbody > tr > .col_cms_com_id > div,
  .dem-edi-pro-tab > table > tbody > tr > .col_cms_com_id > div > span > div {
    text-align: center !important;
  }

  .dem-edi-pro-tab--no-caso > span > svg {
    font-size: 19px;
    color: #d9534f;
    vertical-align: -5px;
    margin-right: 3px;
  }

  /* -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= */

  .dem-edi-pro-tab > table > tbody > tr > td.cpnt-tabela-editar.col_valor_des {
    min-width: 140px;
  }

  .dem-edi-pro-tab > table > tbody > tr > td.col_id_pco_item {
    padding: 0px !important;
  }
    .dem-edi-pro-tab > table > tbody > tr > td.col_id_pco_item > div > span > table {
      height: 100%;
      width: 100%;
      cursor: pointer;
    }
      .dem-edi-pro-tab > table > tbody > tr > td.col_id_pco_item > div > span > table > tr > td {
        padding: 10px;
      }


  .dem-edi-pro-tab > table > tbody > tr > td > div > span > button.diff,
  .dem-edi-pro-tab > table > tbody > tr > td > div > span > span > button.diff {
    border: none !important;
    background: none !important;
    padding: 0px !important;
    margin: 0px 5px !important;
  }

  .dem-pro-tab-diff {
    width: 100%;
    border-collapse: separate;
  }
    .dem-pro-tab-diff > tbody > tr > th,
    .dem-pro-tab-diff > tbody > tr > td {
      border: 1px solid #ccc;
      text-align: center;
      padding: 5px;
      border-top: none;
      border-left: none;
    }
    .dem-pro-tab-diff > tbody > tr > th:first-child,
    .dem-pro-tab-diff > tbody > tr > td:first-child {
      width: 100px;
      text-align: right;
      padding-right: 10px;
    }
    .dem-pro-tab-diff > tbody > tr:first-child > th {
      border-top: 1px solid #ccc;
    }
    .dem-pro-tab-diff > tbody > tr > th:first-child,
    .dem-pro-tab-diff > tbody > tr > td:first-child {
      border-left: 1px solid #ccc;
    }
    .dem-pro-tab-diff > tbody > tr:first-child > th:first-child {
      border-top-left-radius: 5px;
    }
    .dem-pro-tab-diff > tbody > tr:first-child > th:last-child {
      border-top-right-radius: 5px;
    }
    .dem-pro-tab-diff > tbody > tr:last-child > td:first-child {
      border-bottom-left-radius: 5px;
    }
    .dem-pro-tab-diff > tbody > tr:last-child > td:last-child {
      border-bottom-right-radius: 5px;
    }

    .dem-edi-pro-tab > table > tbody > tr.cpnt-tabela-linha-adicional > td {
      padding: 10px;
    }

  .porcentagem-input {
    width: 100%;
  }
    .porcentagem-input > .cpnt-app-select {
      width: 50px !important;
      margin-right: 10px;
    }
    .porcentagem-input > .cpnt-app-input {
      width: calc(100% - 50px - 10px);
    }
</style>

<script>
  export default {
    props: {
      cpntDemanda: {
        required: true
      },
      cpntDemandaId: {
        required: true
      },
      cpntDemandaFlag: {
        required: false,
        default: function () {
          return ''
        }
      },

      cpntPDocNFEmitida: {
        required: true
      },
      cpntPDocDocs: {
        required: true
      },
      cpntPDV: {
        required: true
      },
      cpntPDocTp: {
        required: true
      },
      cpntIdVei: {
        required: false
      },
      cpntIdPet: {
        required: false
      },
      cpntIdCon: {
        required: true
      },
      cpntIdConPessoa: {
        required: true
      },
      cpntIdConTpCon: {
        required: true
      },
      cpntIdConUF: {
        required: true
      },
      cpntIdConIdPais: {
        required: true
      },
      cpntDemandaTotal: {
        required: true
      },
      cpntFinStatus: {
        required: true
      },
      cpntVetorDetalhes: {
        required: false,
        defualt: function () {
          return []
        }
      }
    },
    components: {
      'App-Relatorio-Detalhe-Custo': () => import('@/components/produto/relatorios/Relatorio-Detalhe-Custo.vue'),
      'App-Status-2': () => import('@/components/rf-geral/status/RF-Status-2.vue'),
      'App-Tabela': () => import('@/components/_geral/Tabela.vue'),
      'App-Explica': () => import('@/components/rf-geral/explica/RF-Explica.vue'),
      'Demanda-Editar-Produtos-Tabela-Item': () => import('./Demanda-Editar-Produtos-Tabela-Item.vue'),
      'Demanda-Editar-Produtos-Tabela-Item-2': () => import('./Demanda-Editar-Produtos-Tabela-Item-2.vue'),
      'App-Produto-Sit-Fiscal-Formulario': () => import('@/components/produto/sit-fiscal/Produto-Sit-Fiscal-Formulario.vue'),
      'App-Controle-Processo-Editar-Varios': () => import('@/components/controle-processo/painel/Controle-Processo-Editar-Varios.vue'),
      // 'App-Produto-Fabricado-Consumo': () => import('@/components/produto/fabricado/Produto-Fabricado-Consumo.vue')
    },
    data: function () {
      return {
        time: '',
        statusGeral: '',
        checkbox: [],
        editar: null,
        colunas: [],
        linha: [],
        route: '',
        tabper: '',
        method: 'POST',
        field: {},
        fieldVir: {},
        where: {},
        order: {},
        estruturaQueryGet: [
          [ 'SemPaginacao', 'type', 'countAll', 'limit', 'field', 'field_virtual', 'where', 'order' ]
        ],
        botaoCopiar: undefined,
        botaoCusto: undefined,
        botaoReinicializar: undefined,
        botaoModificar: undefined,
        botaoModificaCancela: undefined,
        botaoEditar: undefined,
        botaoExcluir: undefined,
        campoEditar: {},
        dialog: null,
        sit_fiscal: null,
        pco_status: null,
        pco_editar: null,
        consumo: null,
        custo: false,
        detalheCusto: null
      }
    },
    mounted: function () {
      // SETA O STATUS DA PAGINA
      this.demEdiProTabSetarStatusGeral('carregando')

      // INICIA CARREGAMENTO
      this.demEdiProTabBuscarLinhas()
    },
    methods: {
      demEdiProTabSetarLinhas: function (vetor) {
        // INICIA A VARIAVEL
        var reinicializar = undefined

        // IMPORA A FUNÇÃO CALCULA A FOR DA LETRA
        const FUN_VERIFICA_COR_LETRA = require('@/assets/js/Funcoes-Gerais.js').FUN_VERIFICA_COR_LETRA

        // SETA O VALOR DO CAMPO
        this.pco_status = null
        this.pco_editar = null

        // PEGA OS VALORES
        for (var indexI in vetor) {
          // SETA O NUMERO DO ITEM NA TABELA
          vetor[indexI].nItem = (Number(indexI) + 1)

          // CARREGA AS INFORMAÇÕES DE DESCONTO
          vetor[indexI].tpDesconto = [ '', null, undefined ].indexOf(vetor[indexI].valor_des_por) !== -1 ? 'R$' : '%'
          if ([ '', null, undefined ].indexOf(vetor[indexI].valor_des_por) !== -1) {
            vetor[indexI].valor_des_por = Number(vetor[indexI].valor_tot) === 0 ? '0' : ((Number(vetor[indexI].valor_des_fixo) / Number(vetor[indexI].valor_tot)) * 100).toFixed(2)
          } else {
            vetor[indexI].valor_des_fixo = ((Number(vetor[indexI].valor_tot) * Number(vetor[indexI].valor_des_por)) / 100).toString()
          }

          // VERIFICA SE DEVE COLOCAR COLUNA DE STATUS DO PROCESSO
          vetor[indexI].status_processo = null
          if ([ '', null, undefined ].indexOf(vetor[indexI].id_pco_item) === -1) {
            // SETA OS DADOS DO CONTROLE DE PROCESSOS
            vetor[indexI].status_processo = {
              tipo: 'venda',
              id: vetor[indexI].id_pco_item,
              nome: vetor[indexI].id_pco_item_nome,
              cor_letra: FUN_VERIFICA_COR_LETRA(vetor[indexI].id_pco_item_cor_fundo),
              cor_fundo: vetor[indexI].id_pco_item_cor_fundo
            }

            // VERIFICA SE AS LISTA SÃO IGUAIS PARA TODOS OS REGISTROS
            if (this.pco_status === null && [ '', null, undefined, '0', 0 ].indexOf(vetor[indexI].id_pco_item_id_pco_status_item_id_pco_status) === -1) {
              this.pco_status = vetor[indexI].id_pco_item_id_pco_status_item_id_pco_status
            } else if (this.pco_status !== null && vetor[indexI].id_pco_item_id_pco_status_item_id_pco_status !== this.pco_status) {
              this.pco_status = ''
            }
          }

          // // INICIA O NOME DO CASO
          // vetor[indexI]._p_id_sf2_nome = ''

          // // VERIFICA SE TEM CASO SELECIONADO
          // if ([ '', null, undefined ].indexOf(vetor[indexI].p_id_sf2_id_caso) === -1) {
          //   // SETA O NOME DO CASO
          //   vetor[indexI]._p_id_sf2_nome += vetor[indexI].p_id_sf2_id_caso_nome

          //   // SETA O NOME DO CONTATO DO CASO
          //   if ([ '', null, undefined, '0' ].indexOf(vetor[indexI].p_id_sf2_id_pro) === -1) {
          //     vetor[indexI]._p_id_sf2_nome += ' | ' + vetor[indexI].id_pro_nome
          //   }

          //   // SETA O NOME DO CONTATO DO CASO
          //   if ([ '', null, undefined, '0' ].indexOf(vetor[indexI].p_id_sf2_id_con_nome) === -1) {
          //     vetor[indexI]._p_id_sf2_nome += ' | ' + vetor[indexI].p_id_sf2_id_con_nome
          //   }

          //   // SETA A UF DO CASO
          //   if ([ '', null, undefined ].indexOf(vetor[indexI].p_id_sf2_id_uf) === -1) {
          //     vetor[indexI]._p_id_sf2_nome += ' | ' + vetor[indexI].p_id_sf2_id_uf
          //   }

          //   // SETA O NOME DO CONTATO DO CASO
          //   if ([ '', null, undefined ].indexOf(vetor[indexI].p_id_sf2_ncm) === -1) {
          //     vetor[indexI]._p_id_sf2_nome += ' | NCM ' + vetor[indexI].p_id_sf2_ncm
          //   }

          //   // SETA O NOME DO CONTATO DO CASO
          //   if ([ '', null, undefined ].indexOf(vetor[indexI].p_id_sf2_id_cfop) === -1) {
          //     vetor[indexI]._p_id_sf2_nome += ' | CFOP ' + vetor[indexI].p_id_sf2_id_cfop + ' - ' + vetor[indexI].p_id_sf2_id_cfop_descricao
          //   }
          // }

          // INICIA O NOME DO CASO
          vetor[indexI]._p_id_sf2_nome = ''
          vetor[indexI]._p_id_sf2_title = ''

          // VERIFICA SE TEM CASO SELECIONADO
          if ([ '', null, undefined ].indexOf(vetor[indexI].p_id_sf2_id_caso) === -1) {
            // SETA O NOME DO CASO
            vetor[indexI]._p_id_sf2_nome = vetor[indexI].p_id_sf2_id_caso_nome
            vetor[indexI]._p_id_sf2_title = vetor[indexI].p_id_sf2_id_caso_nome

            // SETA O ESTADO DO CASO
            if ([ '', null, undefined, '0' ].indexOf(vetor[indexI].p_id_sf2_id_uf) === -1) {
              vetor[indexI]._p_id_sf2_title += ' | UF: ' + vetor[indexI].p_id_sf2_id_uf
            }

            // SETA O CONTATO DO CASO
            if ([ '', null, undefined, '0' ].indexOf(vetor[indexI].p_id_sf2_id_con_nome) === -1) {
              vetor[indexI]._p_id_sf2_title += ' | Contato: ' + vetor[indexI].p_id_sf2_id_con_nome
            }

            // SETA O NCM DO CASO
            if ([ '', null, undefined ].indexOf(vetor[indexI].p_id_sf2_ncm) === -1) {
              vetor[indexI]._p_id_sf2_title += ' | NCM: ' + vetor[indexI].p_id_sf2_ncm
            }

            // SETA O CONTATO DO CASO
            if ([ '', null, undefined, '0' ].indexOf(vetor[indexI].p_id_sf2_id_pro) === -1) {
              vetor[indexI]._p_id_sf2_title += ' | Produto: ' + vetor[indexI].id_pro_nome
            }

            // SETA O NCM DO CASO
            if ([ '', null, undefined ].indexOf(vetor[indexI].p_id_sf2_id_cfop) === -1) {
              vetor[indexI]._p_id_sf2_title += ' | CFOP ' + vetor[indexI].p_id_sf2_id_cfop
              // + ' - ' + vetor[indexI].p_id_sf2_id_cfop_descricao
            }

            // SETA O STATUS DE EXCLUIDO PARA O CASO
            if (vetor[indexI].p_id_sf2_status !== '1') {
              vetor[indexI]._p_id_sf2_title += ' | Caso ' + vetor[indexI].p_id_sf2 + ' Excluído'
            }
          }

          // VERIFICA SE TEM DIFERENÇA NOS CASO DOS PRODUTOS
          if ([ '', null, undefined ].indexOf(vetor[indexI].virtual_p_chk_caso) === -1) {
            // INICIA O VALOR DO CAMPO
            vetor[indexI].virtual_check_caso = { qtde: 0, diff: {}, caso_atual: '', explica: null }

            // VERIFICA SE TEM ALGUM ERRO
            if (vetor[indexI].virtual_p_chk_caso.code !== '200' && [ '', null, undefined ].indexOf(vetor[indexI].virtual_p_chk_caso.data) === -1) {
              // JUNTA OS VALORES RECEBIDOS COM O VALOR DO VETOR
              vetor[indexI].virtual_check_caso.diff = Object.assign(vetor[indexI].virtual_check_caso.diff, vetor[indexI].virtual_p_chk_caso.data.diff)

              // ATUALIZA A QUANTIDADE DE DIFERENÇAS
              vetor[indexI].virtual_check_caso.qtde = Object.keys(vetor[indexI].virtual_check_caso.diff).length

              // SETA A EXPLICAÇÃO
              vetor[indexI].virtual_check_caso.explica = { mensagem: 'Existe(em) ' + vetor[indexI].virtual_check_caso.qtde + ' diferença(s) entre as informações fiscais neste item em relação ao seu cadastro atual.<br/><br/>Clique aqui para visualizar as diferenças.', posicaoMy: 'top right', posicaoAt: 'bottom left' }

              // FINALIZA A TABELA
              var tabela = '<br/><br/><table class="dem-pro-tab-diff">'

              // SETA O TITULO DA TABELA
              tabela += '<tr>'
                  tabela += '<th>'
                    tabela += 'Campo'
                  tabela += '</th>'

                  tabela += '<th>'
                    switch (this.cpntDemanda) {
                      case 'venda':
                        tabela += 'Venda'
                        break

                      case 'compra':
                        tabela += 'Compra'
                        break

                      case 'dev_cliente':
                        tabela += 'Dev. Cliente'
                        break

                      case 'dev_fornecedor':
                        tabela += 'Dev. Fornecedor'
                        break
                    }
                  tabela += '</th>'

                  tabela += '<th>'
                    tabela += 'Sit Fiscal'
                  tabela += '</th>'
                tabela += '</tr>'

              // JUNTA OS VALORES NOS CAMPOS
              for (var indexE in vetor[indexI].virtual_check_caso.diff) {
                tabela += '<tr>'
                  tabela += '<td>'
                    tabela += indexE
                  tabela += '</td>'

                  tabela += '<td>'
                    tabela += vetor[indexI].virtual_check_caso.diff[indexE].ven_pro
                  tabela += '</td>'

                  tabela += '<td>'
                    tabela += vetor[indexI].virtual_check_caso.diff[indexE].sit_fiscal
                  tabela += '</td>'
                tabela += '</tr>'
              }
              
              // FINALIZA A TABELA
              tabela += '</table>'
              
              // SETA A TABELA
              vetor[indexI].virtual_check_caso.explica.mensagem += tabela
            }

            // SETA OS DADOS DO CASO ATUAL
            if ([ '', null, undefined ].indexOf(vetor[indexI].virtual_p_chk_caso.ref) === -1 && [ '', null, undefined ].indexOf(vetor[indexI].virtual_p_chk_caso.ref.id_caso_atual) === -1) {
              vetor[indexI].virtual_check_caso.caso_atual = vetor[indexI].virtual_p_chk_caso.ref.id_caso_atual
            }
          }         

          // SETA A FUNÇÃO PARA REINICIALIZAR A SITUAÇÃO FISCAL DO PRODUTO
          if (reinicializar === undefined && [ '', null, undefined ].indexOf(vetor[indexI].virtual_check_caso) === -1 && (vetor[indexI].p_id_sf2_status !== '1' || [ '', null, undefined ].indexOf(vetor[indexI].p_id_sf2) !== -1 || vetor[indexI].virtual_check_caso.qtde >= 1)) {
            reinicializar = () => { 
              if (confirm('Deseja reinicializar a situação fiscal de TODOS os itens da venda?')) {
                this.demEdiProTabReinicializarSitFiscal()
              }
            }
          }

          // VERIFICA O HISTORIO DO CUSTO EXISTE
          if (vetor[indexI].virtual_custo_historico !== undefined) {
            vetor[indexI].custo_historico_por_produto = [ vetor[indexI].virtual_custo_historico ]
          }
        }

        // SETA A FUNÇÃO REINICIALIZAR
        this.botaoReinicializar = [ 'NFCe', 'NFe' ].indexOf(this.cpntPDocTp) !== -1 ? reinicializar : undefined

        // SETA A FUNÇÃO REINICIALIZAR
        this.botaoCusto = this.demEdiProTabGerarCusto

        // SETA OS VALORES RECEBIDOS
        this.linha = vetor

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // MANDA ABRIR OS DETALHES DA LINHA
        setTimeout(() => { this.demEdiProTabAbrirDetalhes() }, 0)
      },
      demEdiProTabAbrirDetalhes: function (tentativa = 0) {
        if (tentativa <= 10) {
          if (this.statusGeral === '' && [ '', null, undefined ].indexOf(this.cpntVetorDetalhes) === -1 && this.cpntVetorDetalhes.length >= 1 && [ '', null, undefined ].indexOf(this.$refs.tabela) === -1 && [ '', null, undefined ].indexOf(this.$refs.tabela.cpntTabelaOnChangeLinhaAdicional) === -1) {
            for (var index in this.cpntVetorDetalhes) {
              if ([ '', null, undefined ].indexOf(this.cpntVetorDetalhes[index]) === -1 && this.$refs.tabela.linhaAdi.indexOf(this.cpntVetorDetalhes[index]) === -1) {
                this.$refs.tabela.cpntTabelaOnChangeLinhaAdicional(JSON.parse(JSON.stringify(this.cpntVetorDetalhes[index])), false)
              }
            }
          } else {
            setTimeout(() => { this.demEdiProTabAbrirDetalhes((tentativa + 1)) }, 0)
          }
        }
      },
      demEdiProTabSetarEditar: function (linha) {
        // OCULTA A LISTA DE DADOS
        this.demEdiProTabOcultarOpcoesSuspensas()

        // SETA OS DADOS QUE SERÁ EDITADO
        this.editar = linha

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      demEdiProTabMostrarBotaoEditar: function () {
        // SETA O BOTÃO COPIAR
        this.botaoCopiar = [ 'dev_cliente', 'dev_fornecedor', 'compra' ].indexOf(this.cpntDemanda) !== -1 ? undefined : this.demEdiProTabCopiarProduto

        // LIMPA O BOTÃO
        this.botaoEditar = ([ 'dev_cliente', 'dev_fornecedor', 'compra' ].indexOf(this.cpntDemanda) !== -1 || this.cpntPDV === true || this.cpntFinStatus === 's' || this.cpntPDocNFEmitida === true) ? undefined : this.demEdiProTabEditarItem

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      demEdiProTabMostrarBotaoExcluir: function () {
        // LIMPA O BOTÃO
        this.botaoExcluir = (this.cpntDemandaFlag !== '' || this.cpntPDV === true || this.cpntFinStatus === 's' || this.cpntPDocNFEmitida === true || this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(true, [ 17 ], null, [ 10 ], null, [ 76 ], null, false) === false) ? undefined : this.demEdiProTabExcluir

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      demEdiProTabBuscarLinhas: function () {
        if ([ '', null, undefined ].indexOf(this.cpntDemanda) === -1 && [ '', null, undefined ].indexOf(this.cpntDemandaId) === -1) {
          // VERIFICA SE DEVE MOSTRAR O BOTÃO EDITAR
          this.demEdiProTabMostrarBotaoEditar()

          // VERIFICA SE DEVE MOSTRAR O BOTÃO EXCLUIR
          this.demEdiProTabMostrarBotaoExcluir()

          // LIMPA O VETOR DE DADOS
          this.campoEditar = {}

          // LIMPA A VARIAVEL DE ORDENAÇÃO
          this.order = {}

          // VERIFICA A DEMANDA QUE ESTÁ SENDO CARREGADA
          if ([ 'venda' ].indexOf(this.cpntDemanda) !== -1) {
            // ORDENANDO PELO CAMPO SELETOR
            // IMPLEMENTADO NO DIA 10/09/2021 11:49, POIS CONFORME INFORMADO PELO RAPHAEL, ESTAVA FALTANDO ESSA ORDENAÇÃO.
            if (this.$store.state.configuracoes.venda.doc.cfg_campo_sel === true) {
              this.order = { cs_nome: 'asc' }
            }

            // SETA O TIPO DE ORDENAÇÃO
            // 25/09/2020 10:30 - Alterado para atender o cliente James CLU 1739
            // Corrigi provisoriamente a ordenação conforme solicitado pelo Raphael,
            // na tabela deveria ordenar pelo campo código, porem como ele é um char, acaba saindo uma ordenação errada do MYSQL. 
            // Este caso será analisando novamente no futuro provavelmente.
  
            // 09/09/2021 17:30 - Cliente James CLU 1739, solicitou que seja criado a opção ordenação por ordem alfabetica
            switch (this.$store.state.configuracoes.venda.ven.cfg_ordem) {
              case '0':
                this.order = Object.assign(this.order, { id_pro: 'asc', id: 'asc' })
                break
  
              case '1':
                this.order = Object.assign(this.order, { data: 'asc', id: 'asc' })
                break
  
              case '2':
                this.order = Object.assign(this.order, { id_pro_id_cat_nome: 'asc', id_pro_nome: 'asc', id: 'asc' })
                break
  
              case '3':
                this.order = Object.assign(this.order, { id_pro_nome: 'asc', id: 'asc' })
                break
            }
          } else if ([ 'compra' ].indexOf(this.cpntDemanda) !== -1) {
            // SETA O TIPO DE ORDENAÇÃO
            // 25/09/2020 10:30 - Alterado para atender o cliente James CLU 1739
            // Corrigi provisoriamente a ordenação conforme solicitado pelo Raphael,
            // na tabela deveria ordenar pelo campo código, porem como ele é um char, acaba saindo uma ordenação errada do MYSQL. 
            // Este caso será analisando novamente no futuro provavelmente.
  
            // 09/09/2021 17:30 - Cliente James CLU 1739, solicitou que seja criado a opção ordenação por ordem alfabetica
            switch (this.$store.state.configuracoes.compra.com.cfg_ordem) {
              case '0':
                this.order = Object.assign(this.order, { id_pro: 'asc', id: 'asc' })
                break
  
              case '1':
                this.order = Object.assign(this.order, { data: 'asc', id: 'asc' })
                break
  
              case '2':
                this.order = Object.assign(this.order, { id_pro_id_cat_nome: 'asc', id_pro_nome: 'asc', id: 'asc' })
                break
  
              case '3':
                this.order = Object.assign(this.order, { id_pro_nome: 'asc', id: 'asc' })
                break
            }
          }

          // SETA AS COLUNAS DA TABELA
          var colunas = [
            { mPer: 2,  chave: 'detalhe',                            nome: 'Detalhe',                                     tipo: 'mostrar'  },
            { mPer: 3,  chave: 'id',                                                                                      tipo: 'checkbox' },
            { mPer: 0,  chave: 'nItem',                              nome: 'Item',                                                         },
            { mPer: 1,  chave: 'cs_nome',                            nome: 'Campo Seletor',         acao: this.demEdiProTabVerificarAcoes  },
            { mPer: 0,  chave: 'data_ptbr',                          nome: 'Data',                                                         },
            { mPer: 1,  chave: 'id_pro_codigo',                      nome: 'Cód.',                                                         },
            { mPer: 2,  chave: 'id_pro_nome',                        nome: 'Nome',                                                         },
            { mPer: 1,  chave: 'id_pro_ncm',                         nome: 'NCM/SH',                acao: this.demEdiProTabVerificarAcoes  },
            { mPer: 1,  chave: 'caso',                               nome: 'CASO',                  acao: this.demEdiProTabVerificarAcoes  },
            { mPer: 1,  chave: 'id_pro_id_uni',                      nome: 'Uni.',                                                         },
            { mPer: 2,  chave: 'qtde',               slot: 'valor',  nome: 'Qtde.',                 acao: this.demEdiProTabVerificarAcoes  },
            { mPer: 2,  chave: 'valor_uni',          slot: 'valor',  nome: 'Valor Unitário',        acao: this.demEdiProTabVerificarAcoes  },
            { mPer: 2,  chave: 'valor_tot',          slot: 'valor',  nome: 'Valor Total',                                                  },
            { mPer: 1,  chave: 'valor_fre',          slot: 'valor',  nome: 'Frete',                 acao: this.demEdiProTabVerificarAcoes  },
            { mPer: 1,  chave: 'valor_seg',          slot: 'valor',  nome: 'Seguro',                acao: this.demEdiProTabVerificarAcoes  },
            { mPer: 1,  chave: 'valor_des',                          nome: 'Desconto',              acao: this.demEdiProTabVerificarAcoes  },
            { mPer: 1,  chave: 'valor_oda',          slot: 'valor',  nome: 'O.D.A.',                acao: this.demEdiProTabVerificarAcoes  },
            { mPer: 1,  chave: 'cms_com_id',                         nome: 'Vendedor',                                                     },
            { mPer: 1,  chave: 'id_pco_item',                        nome: 'Status do processo'                                            },
            { mPer: 1,  chave: 'xPed',                               nome: 'Nº Pedido',             acao: this.demEdiProTabVerificarAcoes, explica: { mensagem: 'Número do Pedido de Compra', posicaoMy: 'top right', posicaoAt: 'bottom left' } },

            { mPer: 0,  chave: 'p_com_ind',                          nome: 'Com/Ind',               acao: this.demEdiProTabVerificarAcoes, explica: { mensagem: 'Comercialização ou Industrialização: <br/><br/>Esta informação é utilizada para inclusão ou não dos valores de IPI na base de cálculo do ICMS em uma NF-e.<br/><br/>Caso marcada: O sistema não inclui o IPI na base de calculo do ICMS.<br/>Caso desmarcada: O sistema inclui o IPI na base de calculo do ICMS.', posicaoMy: 'top right', posicaoAt: 'bottom left' } },
            { mPer: 1,  chave: 'p_id_cfop',          slot: 'info',   nome: 'CFOP',                  acao: this.demEdiProTabVerificarAcoes  },
            { mPer: 0,  chave: 'p_icms_orig',        slot: 'info',   nome: 'Origem',                acao: this.demEdiProTabVerificarAcoes  },
            { mPer: 1,  chave: 'p_icms_cst',         slot: 'info',   nome: 'CST ICMS',              acao: this.demEdiProTabVerificarAcoes  },
            { mPer: 0,  chave: 'p_icms_bc_mod',      slot: 'info',   nome: 'Mod. BC',               acao: this.demEdiProTabVerificarAcoes  },
            { mPer: 0,  chave: 'p_icms_bc_v',        slot: 'valor',  nome: 'ICMS BC',               acao: this.demEdiProTabVerificarAcoes  },
            { mPer: 0,  chave: 'p_icms_a',           slot: 'valor',  nome: 'ICMS %',                acao: this.demEdiProTabVerificarAcoes  },
            { mPer: 0,  chave: 'p_icms_v',           slot: 'valor',  nome: 'ICMS Valor',            acao: this.demEdiProTabVerificarAcoes  },
            { mPer: 0,  chave: 'p_icms_bc_p_r',      slot: 'valor',  nome: '% Redução',             acao: this.demEdiProTabVerificarAcoes  },
            { mPer: 0,  chave: 'p_icms_bc_p_r_c',                    nome: 'Sobre',                 acao: this.demEdiProTabVerificarAcoes  },
            { mPer: 0,  chave: 'p_icms_st_bc_mod',   slot: 'info',   nome: 'Mod. BC ST',            acao: this.demEdiProTabVerificarAcoes  },
            { mPer: 0,  chave: 'p_icms_st_bc_v',     slot: 'valor',  nome: 'ICMS ST BC',            acao: this.demEdiProTabVerificarAcoes  },
            { mPer: 0,  chave: 'p_icms_st_a',        slot: 'valor',  nome: 'ICMS ST %',             acao: this.demEdiProTabVerificarAcoes  },
            { mPer: 0,  chave: 'p_icms_st_v',        slot: 'valor',  nome: 'ICMS ST Valor',         acao: this.demEdiProTabVerificarAcoes  },
            { mPer: 0,  chave: 'p_icms_bc_st_p_r',   slot: 'valor',  nome: 'Redução ST %',          acao: this.demEdiProTabVerificarAcoes  },
            { mPer: 0,  chave: 'p_icms_st_bc_rt',    slot: 'valor',  nome: 'BC ICMS retido por ST', acao: this.demEdiProTabVerificarAcoes  },
            { mPer: 0,  chave: 'p_icms_st_rt',       slot: 'valor',  nome: 'ICMS retido por ST',    acao: this.demEdiProTabVerificarAcoes  },
            { mPer: 0,  chave: 'p_icms_mva_p',       slot: 'valor',  nome: '% MVA',                 acao: this.demEdiProTabVerificarAcoes  },
            
            { mPer: 0,  chave: 'p_icms_fcp_bc_v',    slot: 'valor',  nome: 'FCP BC',               acao: this.demEdiProTabVerificarAcoes  },
            { mPer: 0,  chave: 'p_icms_fcp_a',       slot: 'valor',  nome: 'FCP %',                acao: this.demEdiProTabVerificarAcoes  },
            { mPer: 0,  chave: 'p_icms_fcp_v',       slot: 'valor',  nome: 'FCP Valor',            acao: this.demEdiProTabVerificarAcoes  },
            { mPer: 0,  chave: 'p_icms_fcp_st_bc_v', slot: 'valor',  nome: 'FCP ST BC',            acao: this.demEdiProTabVerificarAcoes  },
            { mPer: 0,  chave: 'p_icms_fcp_st_a',    slot: 'valor',  nome: 'FCP ST %',             acao: this.demEdiProTabVerificarAcoes  },
            { mPer: 0,  chave: 'p_icms_fcp_st_v',    slot: 'valor',  nome: 'FCP ST Valor',         acao: this.demEdiProTabVerificarAcoes  },
            { mPer: 0,  chave: 'p_icms_fcp_st_a_cf', slot: 'valor',  nome: 'Sup. pelo CF.',        acao: this.demEdiProTabVerificarAcoes  },
            { mPer: 0,  chave: 'p_icms_fcp_st_r_a',  slot: 'valor',  nome: 'FCP retido por ST',    acao: this.demEdiProTabVerificarAcoes  },
            { mPer: 0,  chave: 'p_icms_fcp_st_r_bc', slot: 'valor',  nome: 'BC retido por ST',     acao: this.demEdiProTabVerificarAcoes  },

            { mPer: 0,  chave: 'p_pis_cst',          slot: 'info',   nome: 'PIS CST',               acao: this.demEdiProTabVerificarAcoes  },
            { mPer: 0,  chave: 'p_pis_bc_v',         slot: 'valor',  nome: 'PIS BC',                acao: this.demEdiProTabVerificarAcoes  },
            { mPer: 0,  chave: 'p_pis_a',            slot: 'valor',  nome: 'PIS %',                 acao: this.demEdiProTabVerificarAcoes  },
            { mPer: 0,  chave: 'p_pis_v',            slot: 'valor',  nome: 'PIS Valor',             acao: this.demEdiProTabVerificarAcoes  },

            { mPer: 0,  chave: 'p_cofins_cst',       slot: 'info',   nome: 'COFINS CST',            acao: this.demEdiProTabVerificarAcoes  },
            { mPer: 0,  chave: 'p_cofins_bc_v',      slot: 'valor',  nome: 'COFINS BC',             acao: this.demEdiProTabVerificarAcoes  },
            { mPer: 0,  chave: 'p_cofins_a',         slot: 'valor',  nome: 'COFINS %',              acao: this.demEdiProTabVerificarAcoes  },
            { mPer: 0,  chave: 'p_cofins_v',         slot: 'valor',  nome: 'COFINS Valor',          acao: this.demEdiProTabVerificarAcoes  },

            { mPer: 0,  chave: 'p_ipi_cst',          slot: 'info',   nome: 'IPI CST',               acao: this.demEdiProTabVerificarAcoes  },
            { mPer: 0,  chave: 'p_ipi_bc_v',         slot: 'valor',  nome: 'IPI BC',                acao: this.demEdiProTabVerificarAcoes  },
            { mPer: 0,  chave: 'p_ipi_a',            slot: 'valor',  nome: 'IPI %',                 acao: this.demEdiProTabVerificarAcoes  },
            { mPer: 0,  chave: 'p_ipi_v',            slot: 'valor',  nome: 'IPI Valor',             acao: this.demEdiProTabVerificarAcoes  },
            { mPer: 0,  chave: 'p_ipi_enq',          slot: 'info',   nome: 'IPI Enquadramento',     acao: this.demEdiProTabVerificarAcoes  },
            { mPer: 0,  chave: 'p_ipi_selo',         slot: 'info',   nome: 'IPI Selo',              acao: this.demEdiProTabVerificarAcoes  },

            { mPer: 0,  chave: 'p_fed_a',            slot: 'valor',  nome: 'Est. Imp. Federal %',          acao: this.demEdiProTabVerificarAcoes  },
            { mPer: 0,  chave: 'p_fed_v',            slot: 'valor',  nome: 'Est. Imp. Federal Valor',      acao: this.demEdiProTabVerificarAcoes  },
            { mPer: 0,  chave: 'p_est_a',            slot: 'valor',  nome: 'Est. Imp. Estadual %',         acao: this.demEdiProTabVerificarAcoes  },
            { mPer: 0,  chave: 'p_est_v',            slot: 'valor',  nome: 'Est. Imp. Estadual Valor',     acao: this.demEdiProTabVerificarAcoes  }
          ]

          // INCIA A VARIAVEL PARA REMOVER COLUNA
          var remover = []

          // REMOVE O CAMPO SELETOR
          if ([ 'venda' ].indexOf(this.cpntDemanda) === -1) {
            remover.push('cs_nome')
          }

          // REMOVE A COLUNA DE DETALHE
          if ([ 'dev_cliente', 'dev_fornecedor' ].indexOf(this.cpntDemanda) !== -1 && [ 'NFe', 'NFCe' ].indexOf(this.cpntPDocTp) === -1) {
            remover.push('detalhe')
          }

          // REMOVE AS COLUNAS SE NÃO TIVER SELECIONADO DOCUMENTO FISCAL
          // if (this.cpntDemanda === 'venda' && [ 'NFe', 'NFCe' ].indexOf(this.cpntPDocTp) === -1) {
          if ([ 'NFe', 'NFCe', 'NFeFornecedor', 'NFCeFornecedor' ].indexOf(this.cpntPDocTp) === -1) {
            remover = remover.concat([ 'valor_fre', 'valor_seg', 'valor_oda', 'xPed', 'caso', 'p_com_ind', 'p_id_cfop', 'p_icms_orig', 'p_icms_cst', 'p_icms_bc_mod', 'p_icms_bc_v', 'p_icms_a', 'p_icms_v', 'p_icms_bc_p_r', 'p_icms_bc_p_r_c', 'p_icms_st_bc_mod', 'p_icms_st_bc_v', 'p_icms_st_a', 'p_icms_bc_st_p_r', 'p_icms_st_bc_rt', 'p_icms_st_rt', 'p_icms_mva_p', 'p_icms_fcp_bc_v', 'p_icms_fcp_a', 'p_icms_fcp_v', 'p_icms_fcp_st_bc_v', 'p_icms_fcp_st_a', 'p_icms_fcp_st_v', 'p_icms_fcp_st_a_cf', 'p_icms_fcp_st_r_a', 'p_icms_fcp_st_r_bc', 'p_pis_cst', 'p_pis_bc_v', 'p_pis_a', 'p_pis_v', 'p_cofins_cst', 'p_cofins_bc_v', 'p_cofins_a', 'p_cofins_v', 'p_ipi_cst', 'p_ipi_bc_v', 'p_ipi_a', 'p_ipi_enq', 'p_ipi_selo', 'p_fed_a', 'p_fed_v', 'p_est_a', 'p_est_v' ])

            for (var _i in colunas) {
              if ([ 'p_ipi_v', 'p_icms_st_v' ].indexOf(colunas[_i].chave) !== -1) {
                colunas[_i].mPer = 3
              }
            }
          }
          
          // VERIFICA AS COLUNAS QUE DEVE REMOVER
          if ([ 'NFeFornecedor', 'NFCeFornecedor' ].indexOf(this.cpntPDocTp) !== -1) {
            remover = remover.concat([ 'caso', 'id_pco_item', 'xPed', 'cms_com_id' ])
          }

          // VERIFICA SE NÃO TEM O PACOTE DE COMISSIONADO
          if (this.cpntDemanda === 'venda' && this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 27 ], null, null, null, null, null, false) === false) {
            remover = remover.concat([ 'cms_com_id' ])
          }

          // VERIFICA SE DEVE MOSTRAR O CONTROLE DE PROCESSOS
          if (this.cpntDemanda === 'venda' && (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 11 ], null, [ 17 ], null, null, null, false) === false || this.$store.state.pcoAntigo === true)) {
            remover = remover.concat([ 'id_pco_item' ])
          }

          if (this.cpntDemanda === 'venda' && this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 17 ], null, [ 10 ], null, [ 40 ], null, false) === false) {
            remover = remover.concat([ 'valor_uni', 'valor_tot', 'valor_fre', 'valor_seg', 'valor_des', 'valor_oda', 'caso', 'p_com_ind', 'p_id_cfop', 'p_icms_orig', 'p_icms_cst', 'p_icms_bc_mod', 'p_icms_a', 'p_icms_bc_p_r', 'p_icms_bc_p_r_c', 'p_icms_st_bc_mod', 'p_icms_st_a', 'p_icms_bc_st_p_r', 'p_icms_st_bc_rt', 'p_icms_st_rt', 'p_icms_mva_p', 'p_icms_fcp_a', 'p_icms_fcp_st_a', 'p_icms_fcp_st_a_cf', 'p_icms_fcp_st_r_a', 'p_icms_fcp_st_r_bc', 'p_pis_cst', 'p_pis_a', 'p_cofins_cst', 'p_cofins_a', 'p_ipi_cst', 'p_ipi_a', 'p_ipi_enq', 'p_ipi_selo' ])
          }

          // VERIFICA SE DEVE APRESENTAR O CAMPO SELETOR
          if (this.cpntDemanda === 'venda' && this.$store.state.configuracoes.venda.doc.cfg_campo_sel === false) {
            remover = remover.concat([ 'cs_nome' ])
          }
    
          // SETA AS COLUNAS QUE DEVE BUSCAR NO GET
          this.field = {
            id: null,
            data: null,
            id_pro: { j: { codigo: null, nome: null, id_uni: null, ncm: null, status: null, id_cat: { j: { nome: null } }, id_mar: { j: { nome: null } } } },
            qtde: null,
            valor_uni_novo: { a: 'valor_uni' },
            valor_tot_novo: { a: 'valor_tot' },
            valor_fre: null,
            valor_seg: null,
            valor_oda: null,
            valor_des_por: null,
            valor_des_fixo: null,
            valor_des_novo: null,

            p_com_ind: null,
            p_id_cfop: { j: { descricao: null , j_demanda: null } },
            p_icms_orig: { j: { ref_icms_origem_desc: null } },
            p_icms_cst: { j: { ref_icms_rt_id: null, ref_icms_cst_desc: null, ref_icms_aa: null, ref_icms_bc_mod: null, ref_icms_a: null, ref_icms_bc_p_r: null, ref_icms_bc_p_r_c: null, ref_icms_st_bc_mod: null, ref_icms_st_a: null, ref_icms_bc_st_p_r: null, ref_icms_st_bc_rt: null, ref_icms_st_rt: null, ref_icms_mva_p: null, ref_icms_fcp_a: null, ref_icms_fcp_st_a: null, ref_icms_fcp_st_a_cf: null, ref_icms_fcp_st_r_a: null, ref_icms_fcp_st_r_bc: null } },
            p_icms_bc_mod: { j: { ref_icms_mod_bc_desc: null } },
            p_icms_a: null,
            p_icms_bc_p_r: null,
            p_icms_bc_p_r_c: null,
            p_icms_st_bc_mod: { j: { ref_icms_mod_bc_st_desc: null } },
            p_icms_st_a: null,
            p_icms_bc_st_p_r: null,
            p_icms_st_bc_rt: null,
            p_icms_st_rt: null,
            p_icms_mva_p: null,
            p_icms_int_a: null,
            p_icms_int_par_p: null,
            p_icms_fcp_a: null,
            p_icms_fcp_st_a: null,
            p_icms_fcp_st_a_cf: null,
            p_icms_fcp_st_r_a: null,
            p_icms_fcp_st_r_bc: null,
            p_icms_bc_v: null,
            p_icms_v: null,
            p_icms_ope_v: null,
            p_icms_dif_v: null,
            p_icms_st_v: null,
            p_icms_st_bc_v: null,
            p_icms_sn_cre_v: null,
            p_icms_int_uf_des_v: null,
            p_icms_int_uf_rem_v: null,
            p_icms_fcp_bc_v: null,
            p_icms_fcp_v: null,
            p_icms_fcp_st_bc_v: null,
            p_icms_fcp_st_v: null,
            p_icms_fcp_st_r_v: null,

            p_pis_cst: { j: { ref_pc_cst_desc: null, ref_pc_a: null, ref_pc_ope: null } },
            p_pis_a: null,
            p_pis_bc_v: null,
            p_pis_v: null,

            p_cofins_cst: { j: { ref_pc_cst_desc: null, ref_pc_a: null, ref_pc_ope: null } },
            p_cofins_a: null,
            p_cofins_bc_v: null,
            p_cofins_v: null,

            p_ipi_cst: { j: { ref_ipi_cst_desc: null, ref_ipi_ope: null, ref_ipi_a: null, ref_ipi_enq: null, ref_ipi_selo: null } },
            p_ipi_a: null,
            p_ipi_enq: { j: { ref_ipi_enq_desc: null } },
            p_ipi_selo: { j: { ref_ipi_tipo: null, ref_ipi_cor: null } },
            p_ipi_bc_v: null,
            p_ipi_v: null,

            xPed: null,
            p_fed_a: null,
            p_fed_v: null,
            p_est_a: null,
            p_est_v: null,
            status: null
          }

          // INICIA A VARIAVEL DO CAMPO VIRTUAL SE ELA NÃO EXISTIR
          this.fieldVir = []

          // SETA O CAMPOS VIRTUAL QUE DEVE BUSCAR
          this.fieldVir = this.fieldVir.concat([ 'p_icms_bc_p_r_c_desc' ])

          // VERIFICA SE DEVE COMPARAR OS DADOS DO CASO
          if ((this.cpntPDocNFEmitida === true && [ 'NFCe', 'NFe' ].indexOf(this.cpntPDocTp) !== -1 && this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 17 ], null, [ 10 ], null, [ 13 ], null, false) === true) === false) {
            this.fieldVir = this.fieldVir.concat([ 'p_chk_caso' ])
          }
    
          // SETA A ROTA QUE DEVE CHAMAR
          var route = ''

          // VERIFICA O WHERE QUE DEVE REALIZAR
          switch (this.cpntDemanda) {
            case 'venda':
              // SETA O WHERE QUE DEVE REALIZAR
              this.where = { aAnd: [ { f: 'cod_venda', o: '=', v: this.cpntDemandaId }, { f: 'status', o: '=', v: '1' } ] }

              // SETA A ROTA QUE DEVE CHAMAR
              route = '/venda/produto/get'

              // SETA O NOME DA TABPER
              this.tabper = 'VenPro'

              // SETA OS CAMPOS QUE DEVE RETORNAR DESTE TIPO
              this.field = Object.assign(this.field, {
                cod_venda: null,
                p_id_sf2: { j: { id_pro: null, id_con: { j: { nome: null } }, id_uf: null, id_caso: { j: { nome: null } }, id_cfop: { j: { descricao: null } }, status: null } },
                cms_com_id: { j: { nome: null } },
                id_pco_item: { j: { id_pco_status_item: { j: { nome: { a: 'id_pco_item_nome' }, cor: { a: 'id_pco_item_cor_fundo' }, id_pco_status: { j: { nome: null } } } } } },
                cms_fec_id: null,
                cms_bc: null,
                cms_por: null,
                cms_valor: null,
                cs: { j: { nome: null } },
                fabricado: null
              })

              // VERIFICA SE DEVE BUSCAR O CUSTO DOS PRODUTOS
              if (this.custo === true) {
                // ADICIONA A CHAVE PARA CAMPO VIRTUAL
                this.fieldVir.push('custo_historico')

                // PEGA A COLUNA VALOR UNITARIO
                var index = colunas.findIndex(item => item.chave === 'valor_uni')

                // ADICIONA A COLUNA
                colunas.splice(index, 0, { mPer: 2, chave: 'custo', nome: 'Custo' })
              }
              break
  
            case 'compra':
              // SETA O WHERE QUE DEVE REALIZAR
              this.where = { aAnd: [ { f: 'dem_compra', o: '=', v: this.cpntDemandaId }, { f: 'status', o: '=', v: '1' } ] }

              // SETA A ROTA QUE DEVE CHAMAR
              route = '/demanda/dem-compra/dem-produto/get'

              // SETA O NOME DA TABPER
              this.tabper = 'DemCompraDemProduto'

              // SETA OS CAMPOS QUE DEVE RETORNAR DESTE TIPO
              this.field = Object.assign(this.field, {
                dem_compra: null,
                p_id_sf2: { j: { id_pro: null, id_con: { j: { nome: null } }, id_uf: null, id_caso: { j: { nome: null } }, id_cfop: { j: { descricao: null } }, status: null } }
              })

              // REMOVE CAMPOS QUE NÃO TEM NESTA DEMANDA
              remover = remover.concat([ 'cms_com_id', 'id_pco_item' ])
              break

            case 'dev_cliente':
              // SETA O WHERE QUE DEVE REALIZAR
              this.where = { aAnd: [ { f: 'dem_dev_cliente', o: '=', v: this.cpntDemandaId }, { f: 'status', o: '=', v: '1' } ] }

              // SETA A ROTA QUE DEVE CHAMAR
              route = '/demanda/dem-dev-cliente/dem-produto/get'

              // SETA O NOME DA TABPER
              this.tabper = 'DemDevClienteDemProduto'

              // SETA OS CAMPOS QUE DEVE RETORNAR DESTE TIPO
              this.field = Object.assign(this.field, { 
                dem_dev_cliente: null,
                p_ipi_devol_p: null,
                p_ipi_devol_v: null,
                p_id_sf2: { j: { id_pro: null, id_con: { j: { nome: null } }, id_uf: null, id_caso: { j: { nome: null } }, id_cfop: { j: { descricao: null } }, status: null } },
              })

              // VERIFICA A AÇÃO QUE DEVE REALIZAR
              if (this.cpntDemandaFlag !== '') {
                remover = remover.concat([ 'id', 'valor_fre', 'valor_seg', 'valor_des', 'valor_oda', 'xPed', 'cms_com_id', 'id_pco_item' ])
              }

              // REMOVE CAMPOS QUE NÃO TEM NESTA DEMANDA
              remover = remover.concat([ 'xPed', 'cms_com_id', 'id_pco_item' ])

              // LIMPA O VALOR DO CAMPO
              this.botaoCopiar = undefined
              break

            case 'dev_fornecedor':
              // SETA O WHERE QUE DEVE REALIZAR
              this.where = { aAnd: [ { f: 'dem_dev_fornecedor', o: '=', v: this.cpntDemandaId }, { f: 'status', o: '=', v: '1' } ] }

              // SETA A ROTA QUE DEVE CHAMAR
              route = '/demanda/dem-dev-fornecedor/dem-produto/get'

              // SETA O NOME DA TABPER
              this.tabper = 'DemDevFornecedorDemProduto'

              // SETA OS CAMPOS QUE DEVE RETORNAR DESTE TIPO
              this.field = Object.assign(this.field, { 
                dem_dev_fornecedor: null,
                p_ipi_devol_p: null,
                p_ipi_devol_v: null,
                p_id_sf2: { j: { id_pro: null, id_con: { j: { nome: null } }, id_uf: null, id_caso: { j: { nome: null } }, id_cfop: { j: { descricao: null } }, status: null } },
              })

              // VERIFICA A AÇÃO QUE DEVE REALIZAR
              if (this.cpntDemandaFlag !== '') {
                remover = remover.concat([ 'id', 'valor_fre', 'valor_seg', 'valor_des', 'valor_oda', 'xPed', 'cms_com_id', 'id_pco_item' ])
              }

              // REMOVE CAMPOS QUE NÃO TEM NESTA DEMANDA
              remover = remover.concat([ 'xPed', 'cms_com_id', 'id_pco_item' ])

              // LIMPA O VALOR DO CAMPO
              this.botaoCopiar = undefined
              break
          }

          // REMOVE AS COLUNAS INFORMADAS
          if (remover.length >= 1) {
            colunas = colunas.filter(item => remover.indexOf(item.chave) === -1)
          }
  
          // SETA AS COLUNAS MONTADAS
          if (JSON.stringify(colunas) !== JSON.stringify(this.colunas)) {
            this.colunas = colunas
          }
  
          // SETA A ROTA ATUALIZADA RECEBIDA
          this.route = route
  
          // VERIFICA SE TEM QUE BUSCAR E ATUALIZAR A TABELA       
          if ([ '', null, undefined ].indexOf(this.$refs.tabela) === -1 || this.statusGeral === '') {
            this.demEdiProTabReiniciar()
          } else {
            this.demEdiProTabSetarStatusGeral('')
          }
        }
      },
      demEdiProTabReiniciar: function (tentativa = 0) {
        if (tentativa <= 5) {
          if ([ '', null, undefined ].indexOf(this.$refs.tabela) === -1 && [ '', null, undefined ].indexOf(this.$refs.tabela.cpntTabelaReiniciar) === -1) {
            this.$refs.tabela.cpntTabelaReiniciar()
          } else {
            setTimeout(() => { this.demEdiProTabReiniciar((tentativa + 1)) }, 100)
          }
        }
      },
      demEdiProTabSetarStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      demEdiProTabMontarTitle: function (chave, linha) {
        switch (chave) {
          case 'p_id_cfop':
            return linha.p_id_cfop + ' - ' + linha.p_id_cfop_descricao

          case 'p_icms_orig':
            return linha.p_icms_orig + ' - ' + linha.p_icms_orig_ref_icms_origem_desc

          case 'p_icms_cst':
            return linha.p_icms_cst + ' - ' + linha.p_icms_cst_ref_icms_cst_desc

          case 'p_icms_bc_mod':
            return linha.p_icms_bc_mod + ' - ' + linha.p_icms_bc_mod_ref_icms_mod_bc_desc

          case 'p_icms_st_bc_mod':
            return linha.p_icms_st_bc_mod + ' - ' + linha.p_icms_st_bc_mod_descricao

          case 'p_pis_cst':
            return linha.p_pis_cst + ' - ' + linha.p_pis_cst_ref_pc_cst_desc

          case 'p_cofins_cst':
            return linha.p_cofins_cst + ' - ' + linha.p_cofins_cst_ref_pc_cst_desc

          case 'p_ipi_cst':
            return linha.p_ipi_cst + ' - ' + linha.p_ipi_cst_ref_ipi_cst_desc

          case 'p_ipi_enq':
            return linha.p_ipi_enq + ' - ' + linha.p_ipi_enq_ref_ipi_enq_desc

          case 'p_ipi_selo':
            return linha.p_ipi_selo + ' - ' + linha.p_ipi_selo_ref_ipi_tipo + ' - ' + linha.p_ipi_selo_ref_ipi_cor
        }
      },
      demEdiProTabPorcentagemDescontoTitulo: function (linha) {
        return linha.tpDesconto === '%' ? 'Porcentagem Fixa' : 'Valor Fixo'
      },
      demEdiProTabPorcentagemDescontoValor: function (linha) {
        // INICIA A VARIAVEL
        var valor = ''

        // VERIFICA QUAL CAMPO DEVE USAR
        valor = this.$store.state.FUN_MASCARA_VALOR('VALOR_DECIMAL_FRONT', Number(linha.valor_des_por).toFixed(2))

        // RETORNA O VALOR MONTADO
        return valor
      },
      demEdiProTabFormatarValor: function (valor, chave) {
        // VERIFICA SE O CAMPO TEM VALOR PADRÃO
        if (valor === '' && [ 'qtde', 'valor_uni', 'valor_tot', 'valor_fre', 'valor_seg', 'valor_des', 'valor_oda', 'valor_tot' ].indexOf(chave) !== -1) {
          valor = null
        }

        // CASO NÃO TENHA VALOR, SETA O VALOR 0,00
        switch (valor) {
          case '':
            valor = ''
            break

          case null:
          case undefined:
            valor = '0,00'
            break

          default:
            if ([ 'valor_uni', 'valor_des' ].indexOf(chave) !== -1) {
              valor = this.$store.state.FUN_MASK_VALOR('valorDecimalNovo', valor)
            } else if ([ 'qtde', 'valor_des_por' ].indexOf(chave) !== -1) {
              valor = this.$store.state.FUN_MASCARA_VALOR('VALOR_DECIMAL_FRONT', valor)
            } else {
              valor = this.$store.state.FUN_MASK_VALOR('valorMoeda', valor)
            }
            break
        }

        // RETORNA O VALOR MONTADO
        return valor
      },
      demEdiProTabMontarNomeVendedor: function (linha) {
        // PEGA O NOME DO CONTATO
        var nome = linha.cms_com_id_nome.split(' ')

        // REMOVE TODOS OS VALORES EMBRANCO
        nome = nome.filter(item => item !== '')

        // PEGA A PRIMEIRA LETRA DE CADA PALAVRA
        for (var key in nome) {
          nome[key] = nome[key].substring(0, 1)
        }

        return (linha.cms_com_id + ' - ' + nome.join('')).toUpperCase()
      },
      demEdiProTabMontarExplicaVendedor: function (linha) {
        // INICIA A MENSAGEM QUE SERÁ APRESENTADA NA EXPLICAÇÃO
        var mensagem = '<table class="tab-cms-item"><tr><td colspan="2" style="border-right: none"><div>Comissionado:</div>'
        mensagem += linha.cms_com_id + ' - ' + linha.cms_com_id_nome
        mensagem += '</td><td colspan="2" style="border-left: none"><div>Fechamento:</div>'
        mensagem += (linha.cms_fec_id === '' ? '-' : linha.cms_fec_id)
        mensagem += '</td></tr><tr><td><div>Base de Cálculo:</div> R$ '
        mensagem += this.$store.state.FUN_MASK_VALOR('valorMoeda', linha.cms_bc)
        mensagem += '</td><td><div>Porcentagem:</div>'
        mensagem += linha.cms_por + '%'
        mensagem += '</td><td><div>Valor:</div> '
        mensagem += 'R$ ' + this.$store.state.FUN_MASK_VALOR('valorMoeda', linha.cms_valor)
        mensagem += '</td></tr></table>'

        // RETORNA O VALOR MONTADO
        return mensagem
      },
      demEdiProTabProdutoOnChangeLinhaAdicional: function (linha) {
        this.$refs.tabela.cpntTabelaOnChangeLinhaAdicional(linha.id)
      },
      demEdiProTabProdutoOnClick: function (indexL) {
        if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 6 ], null, [ 12 ], null, [ 78 ], 'or', false) === true) {
          // SETA OS PARAMETROS QUE SERÁ ENVIADO
          var params = { tipo: 'produto', id: this.linha[indexL].id_pro }
  
          // SETA O NOME DA DEMANDA QUE DEVE BUSCAR
          switch (this.cpntDemanda) {
            case 'venda':
              params.demanda = 'dem_venda'
              break

            case 'compra':
              params.demanda = 'dem_compra'
              break
          
            case 'dev_cliente':
              params.demanda = 'dem_dev_cliente'
              break

            case 'dev_fornecedor':
              params.demanda = 'dem_dev_fornecedor'
              break
          }

          // SETA O DOCUMENTO DE PRODUTO SELECIOANADO
          params.p_doc_tp = this.cpntPDocTp

          // SETA O ESTADO QUE DEVE ABRIR O CADASTRO DO PRODUTO
          params.id_con = this.cpntIdCon

          // SETA O ESTADO QUE DEVE ABRIR O CADASTRO DO PRODUTO
          params.uf = this.cpntIdConUF
  
          // SETA O CALLBACK QUE DEVE EXECUTAR
          params.callback = (atualizar) => {
            if (atualizar === true) {
              if ([ 'NFe', 'NFC-e' ].indexOf(this.cpntPDocTp) !== -1 && this.cpntPDocNFEmitida === false) {
                // // PEGA OS CASOS DISPONIVEIS PARA ESSE PRODUTO
                // var caso = dados.sit_fiscal.filter(item => item.id_uf === this.cpntIdConUF && (this.linha[indexL].p_id_caso === '' || item.id_caso === this.linha[indexL].p_id_caso))
  
                // // ATUALIZA O CASO RECEBIDO
                // this.linha[indexL].virtual_check_caso.caso_atual = caso.length >= 1 ? caso[0].id : ''
  
                // MANDA ATUALIZAR A SITUAÇÃO FISCAL DO PRODUTO
                this.demEdiProTabReinicializarSitFiscal([ this.linha[indexL].id ])
              } else {
                this.demEdiProTabBuscarLinhas()
              }
            }
          }
  
          // CHAMA A FUNÇÃO PARA INFORMAR QUE A ROTA FOI ATUALIZADA
          this.$store.commit('SET_ABRIR_CADASTRO_VET', params)
        } else {
          this.demEdiProTabBuscarLinhas()
        }
      },
      demEdiProTabMarcarCheckbox: function (checked, value) {
        // VERIFICA A AÇÃO QUE DEVE REALIZAR COM OS CHECKBOXS
        switch (checked) {
          case true:
            this.checkbox.push(value)
            break

          case false:
            this.checkbox = this.checkbox.filter(item => item !== value)
            break
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      demEdiProTabEditarItem: function () {
        if (this.checkbox.length === 0) {
          this.$store.state.msgWarn('WEB [406]: Selecione um registro para prosseguir.', 'warning')
        // } else if (this.checkbox.length === 1) {
        //   // SETA A VARIAVEL PARA EDIÇÃO DOS CAMPOS DO CASO
        //   this.editar = this.linha.filter(item => item.id === this.checkbox[0])[0]

        //   // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        //   this.time = new Date().getTime()
        } else {
          // SETA A VARIAVEL PARA EDIÇÃO DOS CAMPOS DO CASO
          this.$refs.tabela.editar = new Date().getTime()

          // SETA A FUNÇÃO DO BOTÃO MODIFICAR
          this.botaoModificar = this.demEdiProTabEditar
          this.botaoModificaCancela = this.demEdiProTabEditarCancela
  
          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
        }
      },
      demEdiProTabEditarCancela: function () {
        // SETA A VARIAVEL PARA EDIÇÃO DOS CAMPOS DO CASO
        this.$refs.tabela.editar = ''
        this.$refs.tabela.acoes = null

        // SETA A FUNÇÃO DO BOTÃO MODIFICAR
        this.botaoModificar = undefined
        this.botaoModificaCancela = undefined

        // LIMPAS OS CHECKBOX MARCADOS
        this.checkbox = []

        // LIMPA O VETOR DE CAMPOS
        for (var index in this.campoEditar) {
          delete this.campoEditar[index]
        }

        // LIMPA O VETOR
        this.campoEditar = {}

        // DESTRAVA A TELA
        this.$parent.$emit('DEMANDA_TRAVAR_TELA', false)

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.$refs.tabela.time = new Date().getTime()
        this.time = new Date().getTime()
      },
      demEdiProTabVendedorOnClick: function (id) {
        // INICIA OS PARAMETROS
        var params = { acao: 'ABRIR_CADASTRO', demanda: this.cpntDemanda, id: id, tipo: 'comissao', modelo: 'produto' }
        
        // SETA A FUNÇÃO CALLBACK
        params.callback = (atualizar) => {
          // CHAMA A FUNÇÃO PARA ATUALIZAR A TABELA
          if (atualizar === true) {
            this.demEdiProTabBuscarLinhas() 
          }
        }

        // CHAMA A FUNÇÃO PARA ABRIR OS DADOS
        this.$store.commit('SET_ABRIR_CADASTRO', params)
      },
      demEdiProTabAtualizarDados: function () {
        // TRAVA A TELA
        this.$parent.$emit('DEMANDA_TRAVAR_TELA', true)

        // // MANDA FECHAR O FORMULARIO DE EDIÇÃO
        // this.$refs.tabela.cpntTabelaOnChangeLinhaAdicional(id)

        // ATUALIZA OS DADOS DA DEMANDA
        this.$parent.$emit('DEMANDA_BUSCAR_VALORES', () => {
          // DESTRAVA A TELA
          this.$parent.$emit('DEMANDA_TRAVAR_TELA', false)

          // MANDA ATUALIZAR A TABELA
          this.demEdiProTabBuscarLinhas()
        })
      },
      demEdiProTabEditarItemFechar: function (atualizar) {
        // LIMPA A VARIAVEL DE EDIÇÃO DOS CAMPOS DO CASO
        this.editar = null

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // VERIFICA SE TEM QUE ATUALIZAR A TABELA
        if (atualizar === true) {
          this.$parent.$emit('DEMANDA_BUSCAR_VALORES', () => {
            // DESTRAVA A TELA
            this.$parent.$emit('DEMANDA_TRAVAR_TELA', false)

            // MANDA ATUALIZAR A TABELA
            this.demEdiProTabBuscarLinhas()
          })
        }
      },
      demEdiProTabVerificarAcoes: function (linha, coluna) {
        if ([ 'dev_cliente', 'dev_fornecedor' ].indexOf(this.cpntDemanda) !== -1 && coluna.chave !== 'caso') {
          return false
        } else if (coluna.chave === 'caso' && this.cpntIdConPessoa !== 'e' && ([ '', null, undefined ].indexOf(this.$store.state.licenca.uf) !== -1 || ([ '', null, undefined ].indexOf(this.cpntIdConUF) !== -1 && this.cpntPDocTp === 'NFe'))) {
          return false
        } else {
          // FAZ A VERIFICAÇÃO SE PODE EDITAR
          var editar = this.cpntFinStatus !== 's' && this.cpntPDocNFEmitida === false
          
          // VERIFICA SE PODE SER EDITADO OU NÃO
          return (editar === true && coluna.chave === 'caso') ? [ '', null, undefined ].indexOf(linha.id_pro_ncm) === -1 : editar
        }
      },
      demEdiProTabIniciarEdicaoCampo: function (vetor) {
        // INICIA O VETOR
        var linha = JSON.parse(JSON.stringify(vetor.linha))

        // INICIA O VETOR
        var campo = {}

        // VERIFICA O CAMPO QUE DEVE ABRIR
        switch (vetor.indexCV) {
          case 'qtde':
            campo = {
              options: [],
              tipo: 'input',
              mask: 'VALOR_DECIMAL_CAMPO',
              value: linha[vetor.indexCV]
            }
            break

          case 'id_pro_ncm':
            campo = {
              tipo: 'input',
              value: linha[vetor.indexCV]
            }
            break

          case 'p_icms_a':
          case 'p_icms_st_a':
          case 'p_icms_int_a':
          case 'p_icms_int_par_p':
          case 'p_icms_fcp_a':
          case 'p_icms_fcp_st_a':
          case 'p_icms_fcp_st_r_a':
          case 'p_pis_a':
          case 'p_cofins_a':
          case 'p_ipi_a':
          case 'p_fed_a':
          case 'p_est_a':
            campo = {
              options: [],
              tipo: 'input',
              mask: 'valorMoeda',
              value: linha[vetor.indexCV]
            }
            break

          case 'valor_uni':
            campo = {
              options: [],
              tipo: 'input',
              mask: 'valorDecimalNovo',
              apiEnv: 'valor_uni_novo',
              value: linha[vetor.indexCV]
            }
            break
            
          case 'valor_des':
            // SETA OS DADOS DO CAMPO
            campo = {
              tipo: 'input',
              options: [
                { id: 'R$' },
                { id: '%' }
              ],
              keyMostra: [ 'id' ],
              keyValue: 'id',
              valueS: (linha.tpDesconto === '%' ? { id: '%' } : { id: 'R$' }),
              apiEnv: 'valor_des',
              valueP: this.$store.state.FUN_MASK_VALOR('valorDecimalNovo', JSON.stringify(JSON.parse(linha.valor_des_por))),
              valueF: this.$store.state.FUN_MASK_VALOR('valorMoeda', JSON.stringify(JSON.parse(Number(linha.valor_des_fixo) * 100).toFixed(0)))              
            }

            // SETA O VALOR SOLICITADO
            campo.value = linha.tpDesconto === '%' ? campo.valueP : campo.valueF
            break

          case 'p_icms_fcp_st_a_cf':
          case 'p_icms_mva_p':
          case 'p_icms_bc_p_r':
          case 'p_icms_bc_st_p_r':
          case 'p_icms_st_bc_rt':
          case 'p_icms_st_rt':
          case 'p_icms_fcp_st_r_bc':
          case 'valor_fre':
          case 'valor_seg':          
          case 'valor_oda':
          case 'p_icms_bc_v':
          case 'p_icms_v':
          case 'p_icms_ope_v':
          case 'p_icms_dif_v':
          case 'p_icms_st_v':
          case 'p_icms_st_bc_v':
          case 'p_icms_sn_cre_v':
          case 'p_icms_int_uf_des_v':
          case 'p_icms_int_uf_rem_v':
          case 'p_icms_fcp_bc_v':
          case 'p_icms_fcp_v':
          case 'p_icms_fcp_st_bc_v':
          case 'p_icms_fcp_st_v':
          case 'p_icms_fcp_st_r_v':
          case 'p_pis_bc_v':
          case 'p_pis_v':
          case 'p_cofins_bc_v':
          case 'p_cofins_v':
          case 'p_ipi_bc_v':
          case 'p_ipi_v':
          case 'p_fed_v':
          case 'p_est_v':
            campo = {
              options: [],
              tipo: 'input',
              mask: 'valorMoeda',
              value: linha[vetor.indexCV]
            }
            break

          case 'xPed':
            campo = {
              options: [],
              tipo: 'input',
              value: linha[vetor.indexCV]
            }
            break

          case 'caso':
            campo = {
              tipo: 'select',
              options: [],
              keyValue: 'id',
              keyMostra: [ '_id_caso_nome' ],
              apiEnv: 'id_pro_sf',
              value: ([ '', null, undefined ].indexOf(linha._p_id_sf2_nome) === -1 ? { id: linha.p_id_sf2, _id_caso_nome: linha._p_id_sf2_nome } : ''),
              newOption: () => { this.demEdiProTabAbrirNovaSitFiscal(vetor) },
              onBuscarOptions: (callback) => { this.demEdiProTabOnBuscarCasos(callback, vetor) }
            }
            break

          case 'cs_nome':
            campo = {
              tipo: 'select',
              options: [],
              keyValue: 'id',
              keyMostra: [ 'nome' ],
              apiEnv: 'id_cam_seletor',
              newOption: true,
              value: ([ '', null, undefined, '0', 0 ].indexOf(linha.cs) === -1 ? { id: linha.cs, nome: linha.cs_nome } : ''),
              onBuscarOptions: (callback) => { this.demEdiProTabOnBuscarCampoSeletor(callback, vetor) }
            }
            break

          case 'p_id_cfop':
            campo = {
              tipo: 'select',
              options: [],
              keyValue: 'cfop',
              keyMostra: [ 'cfop', ' - ', 'descricao' ],
              value: { cfop: linha.p_id_cfop, descricao: linha.p_id_cfop_descricao },
              onBuscarOptions: (callback) => { this.demEdiProTabOnBuscarCFOP(callback, vetor) }
            }
            break

          case 'p_icms_orig':
            campo = {
              tipo: 'select',
              options: [],
              keyValue: 'ref_icms_origem_id',
              keyMostra: [ 'ref_icms_origem_id', ' - ', 'ref_icms_origem_desc' ],
              value: { ref_icms_origem_id: linha.p_icms_orig, ref_icms_origem_desc: linha.p_icms_orig_ref_icms_origem_desc },
              onBuscarOptions: (callback) => { this.demEdiProTabOnBuscarOrigem(callback, vetor) }
            }
            break

          case 'p_icms_bc_mod':
            campo = {
              tipo: 'select',
              options: [],
              keyValue: 'ref_icms_mod_bc_id',
              keyMostra: [ 'ref_icms_mod_bc_id', ' - ', 'ref_icms_mod_bc_desc' ],
              value: { ref_icms_mod_bc_id: linha.p_icms_bc_mod, ref_icms_mod_bc_desc: linha.p_icms_bc_mod_ref_icms_mod_bc_desc },
              onBuscarOptions: (callback) => { this.demEdiProTabOnBuscarIcmsModBc(callback, vetor) }
            }
            break

          case 'p_icms_cst':
            campo = {
              tipo: 'select',
              options: [],
              keyValue: 'ref_icms_cst',
              keyMostra: [ 'ref_icms_cst', ' - ', 'ref_icms_cst_desc' ],
              value: { ref_icms_cst: linha.p_icms_cst, ref_icms_cst_desc: linha.p_icms_cst_ref_icms_cst_desc },
              onBuscarOptions: (callback) => { this.demEdiProTabOnBuscarCstIcms(callback, vetor) }
            }
            break

          case 'p_icms_bc_p_r_c':
            campo = {
              tipo: 'select',
              options: [],
              keyValue: 'id',
              keyMostra: [ 'descricao' ],
              value: { id: linha.p_icms_bc_p_r_c, descricao: linha.virtual_p_icms_bc_p_r_c_desc },
              onBuscarOptions: (callback) => { this.demEdiProTabOnBuscarRedSobre(callback, vetor) }
            }
            break

          case 'p_icms_st_bc_mod':
            campo = {
              tipo: 'select',
              options: [],
              keyValue: 'ref_icms_mod_bc_st_id',
              keyMostra: [ 'ref_icms_mod_bc_st_id', ' - ', 'ref_icms_mod_bc_st_desc' ],
              value: { ref_icms_mod_bc_st_id: linha.p_icms_st_bc_mod, ref_icms_mod_bc_st_desc: linha.p_icms_st_bc_mod_ref_icms_mod_bc_st_desc },
              onBuscarOptions: (callback) => { this.demEdiProTabOnBuscarIcmsModBcSt(callback, vetor) }
            }
            break

          case 'p_pis_cst':
            campo = {
              tipo: 'select',
              options: [],
              keyValue: 'ref_pc_cst',
              keyMostra: [ 'ref_pc_cst', ' - ', 'ref_pc_cst_desc' ],
              value: { ref_pc_cst: linha.p_pis_cst, ref_pc_cst_desc: linha.p_pis_cst_ref_pc_cst_desc },
              onBuscarOptions: (callback) => { this.demEdiProTabOnBuscarCstPisCofins(callback, vetor) }
            }
            break
          case 'p_cofins_cst':
            campo = {
              tipo: 'select',
              options: [],
              keyValue: 'ref_pc_cst',
              keyMostra: [ 'ref_pc_cst', ' - ', 'ref_pc_cst_desc' ],
              value: { ref_pc_cst: linha.p_cofins_cst, ref_pc_cst_desc: linha.p_cofins_cst_ref_pc_cst_desc },
              onBuscarOptions: (callback) => { this.demEdiProTabOnBuscarCstPisCofins(callback, vetor) }
            }
            break

          case 'p_ipi_cst':
            campo = {
              tipo: 'select',
              options: [],
              keyValue: 'ref_ipi_cst',
              keyMostra: [ 'ref_ipi_cst', ' - ', 'ref_ipi_cst_desc' ],
              value: { ref_ipi_cst: linha.p_ipi_cst, ref_ipi_cst_desc: linha.p_ipi_cst_ref_ipi_cst_desc },
              onBuscarOptions: (callback) => { this.demEdiProTabOnBuscarCstIpi(callback, vetor) }
            }
            break
          case 'p_ipi_enq':
            campo = {
              tipo: 'select',
              options: [],
              keyValue: 'ref_ipi_enq',
              keyMostra: [ 'ref_ipi_enq', ' - ', 'ref_ipi_enq_desc' ],
              value: { ref_ipi_enq: linha.p_ipi_enq, ref_ipi_enq_desc: linha.p_ipi_enq_ref_ipi_enq_desc },
              onBuscarOptions: (callback) => { this.demEdiProTabOnBuscarCstIpiEnq(callback, vetor) }
            }
            break
          case 'p_ipi_selo':
            campo = {
              tipo: 'select',
              options: [],
              keyValue: 'ref_ipi_selo',
              keyMostra: [ 'ref_ipi_selo', ' - ', 'ref_ipi_tipo', ' - ', 'ref_ipi_cor' ],
              optionInicialNome: 'Selecione',
              value: { ref_ipi_selo: linha.p_ipi_selo, ref_ipi_tipo: linha.p_ipi_selo_ref_ipi_tipo, ref_ipi_cor: linha.p_ipi_selo_ref_ipi_cor },
              onBuscarOptions: (callback) => { this.demEdiProTabOnBuscarCstIpiSelo(callback, vetor) }
            }
            break
        }

        // SETA A CHAVE DO VETOR
        campo.chave = vetor.indexL + '--' + vetor.indexCV

        // VERIFICA SE O CAMPO FOI PREENCHIDO
        if (Object.keys(campo).length >= 2) {
          // SETA O HASH DO CAMPO
          campo.hash = vetor.hash
          campo.id = 'dem-edi-ser-tab-item--' + vetor.indexL + '--' + vetor.indexCV + '--' + vetor.hash

          // SETA OS VALORES RECEBIDOS
          campo.extra = vetor

          // SETA O VALOR INICIAL DO CAMPO
          campo.valueIni = campo.value

          // SETA O VALOR RECEBIDO NO VETOR
          this.campoEditar[campo.chave] = Object.assign({
            id: '',
            hash: '',
            indexL: vetor.indexL,
            indexC: vetor.indexC,
            indexCV: vetor.indexCV,
            tipo: '',
            status: '',
            nome: '',
            keyValue: 'id',
            keyMostra: [ 'nome' ],
            options: [],
            optionInicialNome: '',
            value: '',
            mostrar: true,
            searchMinimo: 4,
            onBuscarOptions: null,
            onChange: this.demEdiProTabIniciarEdicaoOnChangeValue,
            onKeyPressEnter: null
          }, campo)
        } else {
          this.campoEditar[campo.chave] = null
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // SETA O FOCUS NO CAMPO
        if ([ '', null, undefined ].indexOf(this.botaoModificar) !== -1 || (this.checkbox[0] === vetor.linha.id && vetor.indexCV === 'qtde')) {
          this.demEdiProTabIniciarEdicaoFocusCampo(campo.id)
        }
      },
      demEdiProTabIniciarEdicaoFocusCampo: function (chave, tentativa = 0) {
        if (this.$store.state.mobile === false) {
          if (tentativa <= 5) {
            if ([ '', null, undefined ].indexOf(this.$refs[chave]) === -1 && [ '', null, undefined ].indexOf(this.$refs[chave].cpntRealizarFocus) === -1) {
              this.$refs[chave].cpntRealizarFocus()
            } else {
              setTimeout(() => { this.demEdiProTabIniciarEdicaoFocusCampo(chave, (tentativa + 1)) }, 100)
            }
          }
        }
      },
      demEdiProTabIniciarEdicaoOnChangeValue: function (value, id) {
        // PEGA OS DADOS DO CAPMO QUE ESTÁ SENDO EDITADO
        var index = id.split('--')
        
        // SETA A CHAVE QUE DEVE UTILIZAR NO VETOR
        var chave = index[1] + '--' + index[2]

        // SETA O NOME DA CHAVE QUE DEVE ATUALIZAR
        var atu = 'value'
        if (index[2] === 'valor_des' && index[4] === 'p') {
          atu = 'valueS'
        }
        
        // VERIFICA SE É O CAMPO SELETOR
        if (index[2] === 'cs_nome' && value.id === '__NOVO_OPTION__') {
          this.demEdiProTabSalvarCampoSeletor(chave, value)
        } else if ([ '', null, undefined ].indexOf(this.campoEditar[chave]) === -1) {
          // SETA O VALOR RECEBIDO
          this.campoEditar[chave][atu] = value

          // REMOVE A MENSAGEM DE ERRO
          this.campoEditar[chave].mensagem = ''

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
        }

        // VERIFICA SE DEVE ATUALIZAR O VALOR DO CAMPO
        if (index[2] === 'valor_des' && index[4] === 'p') {
          // VERIFICAR TIPO DE DESCONTO
          var tpDesconto = typeof value === 'string' ? value : value.id

          // SETA O VALOR DESEJADO
          this.campoEditar[chave].value = tpDesconto === '%' ? this.campoEditar[chave].valueP : this.campoEditar[chave].valueF
        }
      },
      demEdiProTabSalvarCampoSeletor: function (chave, option) {
        // INICIA AS VARIAVEIS
        var formData = { nome: option._text }

        // FAZ A COMUNICAÇÃO COM A API
        this.$store.state.comunicaAPI('/venda/cam-seletor', 'POST', formData, (retorno) => {
          // LIMPA OS OPTIONS PARA BUSCAR NOVAMENTE AO ABRIR O CAMPO
          this.campoEditar[chave].options = []
          this.campoEditar[chave].value = { id: retorno.ref.id, nome: option.nome }

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // APRESENTA A MENSAGEM DE SUCESSO
          this.$store.state.TRATAR_RET_LOT_API(retorno)
        }, this.demEdiProTabSetarStatusGeral, (apiValid, apiStatus) => {
          // VERIFICA SE TEM QUE CONVERTER O CAMPO
          if ([ '', null, undefined ].indexOf(apiValid.nome) === -1) {
            // SETA O VALOR NO NOVO CAMPO
            apiValid.id_cam_seletor = apiValid.nome

            // REMOVE O CAMPO ANTIGO PARA NÃO APRESENTAR DUAS VEZES
            delete apiValid.id_cam_seletor
          }

          // IMPORTA A FUNÇÃO QUE SERÁ UTILIZADA
          const FUN_TRATAR_VALIDACAO_API = require('@/assets/js/Funcoes-Gerais.js').FUN_TRATAR_VALIDACAO_API

          // FAZ A VERIFICAÇÃO E MONTAGEM DO FORMULARIO
          FUN_TRATAR_VALIDACAO_API(apiValid, apiStatus, this.campoEditar, this)
        })
      },
      demEdiProTabExcluir: function (callback = null) {
        // REMOVE O FOCUS DE QUALQUER CAMPO
        if (document.activeElement !== document.body) {
          document.activeElement.blur()
        }

        // SETA A ROTA QUE DEVE CHAMAR
        var route = ''
        var mensagem = ''

        // VERIFICA O WHERE QUE DEVE REALIZAR
        switch (this.cpntDemanda) {
          case 'venda':
            route = '/venda/produto'
            mensagem = 'Deseja realmente excluir o(s) produto(s) desta venda?'
            break

          case 'dev_cliente':
            route = '/demanda/dem-dev-cliente/dem-produto'
            mensagem = 'Deseja realmente excluir o(s) produto(s) desta devolução do cliente?'
            break

          case 'dev_fornecedor':
            route = '/demanda/dem-dev-fornecedor/dem-produto'
            mensagem = 'Deseja realmente excluir o(s) produto(s) desta devolução do fornecedor?'
            break

          case 'compra':
            route = '/demanda/dem-compra/dem-produto'
            mensagem = 'Deseja realmente excluir o(s) produto(s) desta compra?'
            break
        }

        // VERIFICA SE FOI SELECIONADO ALGUM REGISTRO
        if (this.checkbox.length === 0) {
          this.$store.state.msgWarn('WEB [406]: Selecione ao menos um registro para prosseguir.', 'warning')
        } else if (window.confirm(mensagem)) {
          // INICIA O FORMULARIO
          var formData = []

          // IMPORA A FUNÇÃO CALCULA A FOR DA LETRA
          const FUN_PEGAR_CHAVE_DEMANDA = require('@/assets/js/Funcoes-Gerais.js').FUN_PEGAR_CHAVE_DEMANDA

          // PEGA A CHAVE REFERENCIA
          var chaveD = FUN_PEGAR_CHAVE_DEMANDA(this.cpntDemanda)

          // ADICIONA TODOS OS ITENS NO LOT
          for (var indexC in this.checkbox) {
            // INICIA O VETOR
            var vetor = {}

            // ADICIONA O ID
            vetor.id = this.checkbox[indexC]

            // SETA O ID DA DEMANDA QUE DEVE DELETAR
            vetor[chaveD] = this.cpntDemandaId
            
            // ADICIONA O VALOR MONTADO AO FORMULARIO
            formData.push(vetor)
          }

          // CONVERTE O VALOR EM LOT
          formData = { lot: formData }

          

          // CHAMA FUNÇÃO PARA COMUNICAR COM API
          this.$store.state.comunicaAPI(route, 'DELETE', formData, (apiSuccess) => {
            // PEGA O RETORNO RECEBIDO 
            var retorno = apiSuccess.lot[0]

            // VERIFICA O RESULTADO DA OPERAÇÃO
            switch (retorno.code) {
              case '200':
                // LIMPA OS CHECKBOX SELECIONADOS
                this.checkbox = []

                // APRESENTA A MENSAGEM DE SUCESSO
                this.$store.state.TRATAR_RET_LOT_API(apiSuccess)
      
                // ATUALIZA OS DADOS E DESTRAVA A TELA
                this.$parent.$emit('DEMANDA_BUSCAR_VALORES', () => {
                  // LIMPA O FORMULARIO
                  if (callback !== null && typeof callback === 'function') {
                    callback()
                  }

                  // DESTRAVA A TELA
                  this.$parent.$emit('DEMANDA_TRAVAR_TELA', false)
                })

                // // MANDA ATUALIZAR A TABELA
                // this.demEdiProTabBuscarLinhas()
                break

              default:
                this.$store.state.FUN_API_RET_VALIDA(this, 'campos', retorno.message, retorno.code, {}, true, (campos) => {
                  // SETA OS CAMPOS COM OS ERROS
                  this.campos = campos

                  // SETA O STATUS DA TELA
                  this.$parent.$emit('DEMANDA_TRAVAR_TELA', false)
                })
                break
            }
          }, this.demEdiProTabSetarStatusGeral)
        }
      },
      demEdiProTabAtualizarNCM: function (formDataNCM, callback = null, index = 0) {
        if (formDataNCM.length === 0 || [ '', null, undefined ].indexOf(formDataNCM[index]) !== -1) {
          callback()
        } else {
          // CONVERTE O VALOR RECEBIDO EM JSON STRING
          formDataNCM[index].j_id = JSON.stringify(formDataNCM[index].j_id)

          // CHAMA FUNÇÃO PARA COMUNICAR COM API
          this.$store.state.comunicaAPI('/produto', 'PUT', formDataNCM[index], (apiSuccess) => {
            // PEGA O RETORNO RECEBIDO 
            var retorno = apiSuccess.lot[0]

            // VERIFICA O RESULTADO DA OPERAÇÃO
            switch (retorno.code) {
              case '200':
                this.demEdiProTabAtualizarNCM(formDataNCM, callback, (index + 1))
                break

              default:
                this.$store.state.FUN_API_RET_VALIDA(this, 'campos', retorno.message, retorno.code, {}, true, () => { this.$parent.$emit('DEMANDA_TRAVAR_TELA', false) })
                break
            }
          }, this.demEdiProTabSetarStatusGeral, (apiValid, apiStatus) => {
            this.$store.state.FUN_API_RET_VALIDA(this, 'campos', apiValid, apiStatus, {}, true, () => { this.$parent.$emit('DEMANDA_TRAVAR_TELA', false) })
          })
        }
      },
      demEdiProTabEditar: function (callback = null) {
        // REMOVE O FOCUS DE QUALQUER CAMPO
        if (document.activeElement !== document.body) {
          document.activeElement.blur()
        }

        // CHAMA A FUNÇÃO PARA DESTRAVAR A TELA
        this.$parent.$emit('DEMANDA_TRAVAR_TELA', true)

        // INICIA O VETOR
        var formData = {}
        var formDataNCM = []

        // INICIA A VARIAVEL ITEM
        var item = {}

        // IMPORA A FUNÇÃO CALCULA A FOR DA LETRA
        const FUN_PEGAR_CHAVE_DEMANDA = require('@/assets/js/Funcoes-Gerais.js').FUN_PEGAR_CHAVE_DEMANDA

        // PEGA A CHAVE REFERENCIA
        var chaveD = FUN_PEGAR_CHAVE_DEMANDA(this.cpntDemanda)

        // RODA O VETOR PARA MONTAR O FORMULARIO
        for (var index in this.campoEditar) {
          if (index.indexOf('id_pro_ncm') !== -1) {
            if ([ '', null, undefined ].indexOf(this.campoEditar[index]) === -1 && this.campoEditar[index].value !== this.campoEditar[index].valueIni) {
              // PROCURA A NCM QUE DEVE ATUALIZAR
              var indexN = formDataNCM.findIndex(item => item.ncm === this.campoEditar[index].value)

              // SETA A ATUALIZAÇÃO DOS PRODUTOS QUE DEVE REALIZAR
              if (indexN === -1) {
                formDataNCM.push({ j_id: [ this.linha[this.campoEditar[index].extra.indexL].id_pro ], ncm: this.campoEditar[index].value })
              } else if (formDataNCM[indexN].j_id.indexOf(this.linha[this.campoEditar[index].extra.indexL].id_pro) === -1) {
                formDataNCM[indexN].j_id.push(this.linha[this.campoEditar[index].extra.indexL].id_pro)
              }

              // INICIA A VARIAVEL ITEM
              item = {}

              // SETA O ID DO REGISTRO QUE ESTÁ SENDO EDITADO
              item.id = this.linha[this.campoEditar[index].extra.indexL].id

              // SETA O ID DA DEMANDA QUE DEVE ALTERAR
              item.id_pro_sf = ''

              // VERIFICA O VALOR
              if (this.campoEditar[index].mask === 'VALOR_DECIMAL_CAMPO' && isNaN(item[apiEnv]) !== false) {
                // REMOVE OS PONTOS DA STRING
                while (item[apiEnv].indexOf('.') !== -1) {
                  item[apiEnv] = item[apiEnv].replace('.', '')
                }
                // REMOVE A VIRGULA DA STRING
                while (item[apiEnv].indexOf(',') !== -1) {
                  item[apiEnv] = item[apiEnv].replace(',', '.')
                }
              }

              // SETA O ID DA DEMANDA QUE DEVE ALTERAR
              item[chaveD] = this.cpntDemandaId

              // ADICIONA O ITEM AO VETOR
              formData[item.id] = [ '', null, undefined ].indexOf(formData[item.id]) !== -1 ? item : Object.assign(formData[item.id], item)
            }
          } else if ([ '', null, undefined ].indexOf(this.campoEditar[index]) === -1 && this.campoEditar[index].value !== this.campoEditar[index].valueIni) {
            // INICIA A VARIAVEL ITEM
            item = {}

            // SETA O ID DO REGISTRO QUE ESTÁ SENDO EDITADO
            item.id = this.linha[this.campoEditar[index].extra.indexL].id

            // PEGA O NOME DA CHAVE QUE DEVE ENVIAR
            var apiEnv = [ '', null, undefined ].indexOf(this.campoEditar[index].apiEnv) === -1 ? this.campoEditar[index].apiEnv : this.campoEditar[index].extra.indexCV

            // SETA O VALOR QUE DEVE ATUALIZAR
            item[apiEnv] = this.campoEditar[index].tipo === 'select' ? this.campoEditar[index].value[this.campoEditar[index].keyValue] : this.campoEditar[index].value
            
            // VERIFICA SE TEM QUE TRATAR O CAMPO
            if (this.campoEditar[index].mask === 'valorDecimalNovo') {
              // REMOVE OS PONTOS DA STRING
              while (item[apiEnv].indexOf('.') > -1) {
                item[apiEnv] = item[apiEnv].replace('.', '')
              }
  
              // CONVERTE O NUMERO EM VALOR 
              item[apiEnv] = Number(item[apiEnv].replace(',', '.')).toString()
            } else if (this.campoEditar[index].mask === 'VALOR_DECIMAL_CAMPO' && isNaN(item[apiEnv]) !== false) {
              // REMOVE OS PONTOS DA STRING
              while (item[apiEnv].indexOf('.') !== -1) {
                item[apiEnv] = item[apiEnv].replace('.', '')
              }
              // REMOVE A VIRGULA DA STRING
              while (item[apiEnv].indexOf(',') !== -1) {
                item[apiEnv] = item[apiEnv].replace(',', '.')
              }
            }

            if (apiEnv === 'valor_des') {
              // PEGA O TIPO DE DESCONTO
              var descontoTP = this.campoEditar[index].valueS

              // CONVERTE EM STRING
              descontoTP = typeof descontoTP === 'string' ? descontoTP : descontoTP.id

              // PEGA O VALOR DO DESCONTO
              var valorDes = JSON.parse(JSON.stringify(this.campoEditar[index].value))

              // CONVERTE O VALOR DO DESCONTO EM NUMERO
              if (isNaN(valorDes) !== false) {
                // REMOVE OS PONTOS DA STRING
                while (valorDes.indexOf('.') !== -1) {
                  valorDes = valorDes.replace('.', '')
                }
                // REMOVE A VIRGULA DA STRING
                while (valorDes.indexOf(',') !== -1) {
                  valorDes = valorDes.replace(',', '.')
                }
              }

              // VERIFICA O TIPO DE VALOR QUE DEVE ATUALIZAR
              if (descontoTP === '%') {
                item.valor_des_por = valorDes
              } else {
                item.valor_des_fixo = (Number(valorDes) / 100).toFixed(2)
              }

              // REMOVE A CHAVE QUE NÃO É MAIS UTILIZADA
              delete item.valor_des
            } else {
              item[apiEnv] = item[apiEnv].toString()
            }

            // SETA O ID DA DEMANDA QUE DEVE ALTERAR
            item[chaveD] = this.cpntDemandaId

            // ADICIONA O ITEM AO VETOR
            formData[item.id] = [ '', null, undefined ].indexOf(formData[item.id]) !== -1 ? item : Object.assign(formData[item.id], item)
          }
        }

        // CONVERTE O VALOR EM LOT
        formData = { lot: Object.values(formData) }

        // VERIFICA SE TEM ALGUMA COISA PARA ATUALIZAR
        this.demEdiProTabAtualizarNCM(formDataNCM, (atualizar) => {
          if (formData.lot.length === 0) {
            if (atualizar === false) {
              this.demEdiProTabEditarCancela()
            } else {
              this.$parent.$emit('DEMANDA_BUSCAR_VALORES', () => {
                // EXECUTA A FUNÇÃO CALLBACK RECEBIDA
                if (callback !== null && typeof callback === 'function') {
                  callback()
                }

                // DESTRAVA A TELA
                this.$parent.$emit('DEMANDA_TRAVAR_TELA', false)

                // MANDA ATUALIZAR A TABELA
                this.demEdiProTabBuscarLinhas()
              })
            }
          } else {
            // SETA A ROTA QUE DEVE CHAMAR
            var route = ''

            // VERIFICA A ROTA QUE DEVE CHAMAR
            switch (this.cpntDemanda) {
              case 'venda':
                route = '/venda/produto'
                break

              case 'compra':
                route = '/demanda/dem-compra/dem-produto'
                break
            
              case 'dev_cliente':
                route = '/demanda/dem-dev-cliente/dem-produto'
                break

              case 'dev_fornecedor':
                route = '/demanda/dem-dev-fornecedor/dem-produto'
                break
            }

            // CHAMA FUNÇÃO PARA COMUNICAR COM API
            this.$store.state.comunicaAPI(route, 'PUT', formData, (apiSuccess) => {
              // PEGA O RETORNO RECEBIDO 
              var retorno = apiSuccess.lot[0]

              // FINALIZA O PROCESSO DE CANCELAMENTO DA TELA
              this.demEdiProTabEditarCancela()

              // VERIFICA O RESULTADO DA OPERAÇÃO
              switch (retorno.code) {
                case '200':
                  // APRESENTA A MENSAGEM DE SUCESSO
                  this.$store.state.TRATAR_RET_LOT_API(apiSuccess)

                  // LIMPA O VETOR DE DADOS
                  this.campoEditar = {}

                  // ATUALIZA OS DADOS E DESTRAVA A TELA
                  this.$parent.$emit('DEMANDA_BUSCAR_VALORES', () => {
                    // EXECUTA A FUNÇÃO CALLBACK RECEBIDA
                    if (callback !== null && typeof callback === 'function') {
                      callback()
                    }

                    // DESTRAVA A TELA
                    this.$parent.$emit('DEMANDA_TRAVAR_TELA', false)

                    // MANDA ATUALIZAR A TABELA
                    this.demEdiProTabBuscarLinhas()
                  })
                  break

                default:
                  this.$store.state.FUN_API_RET_VALIDA(this, 'campos', retorno.message, retorno.code, {}, true, () => {  
                    this.$parent.$emit('DEMANDA_BUSCAR_VALORES', () => {
                      // EXECUTA A FUNÇÃO CALLBACK RECEBIDA
                      if (callback !== null && typeof callback === 'function') {
                        callback()
                      }

                      // DESTRAVA A TELA
                      this.$parent.$emit('DEMANDA_TRAVAR_TELA', false)

                      // MANDA ATUALIZAR A TABELA
                      this.demEdiProTabBuscarLinhas()
                    })
                  })
                  break
              }
            }, this.demEdiProTabSetarStatusGeral, (apiValid, apiStatus) => {
              this.$store.state.FUN_API_RET_VALIDA(this, 'campos', apiValid, apiStatus, {}, true, () => {
                // SETA O STATUS DA TELA
                this.$parent.$emit('DEMANDA_TRAVAR_TELA', false)

                // MANDA ATUALIZAR A TABELA
                this.demEdiProTabBuscarLinhas()
              })
            })
          }
        })
      },
      demEdiProTabOnBuscarCampoSeletor: function (callback, vetor, total = null, registros = []) {
        if (total === null || total < registros.length) {
          // MONTA O QUERY GET
          var queryGet = { type: 'list', limit: { row: registros.length, qty: 1000 } }

          // SETA OS CAMPOS QUE DEVE RETORNAR
          queryGet.field = { id: null, nome: null }

          // SETA O WHERE QUE DEVE REALIZAR
          queryGet.order = { nome: 'asc' }
  
          // FAZ A BUSCA DOS DADOS
          this.$store.state.comunicaAPI('/venda/cam-seletor/get/', 'GET', queryGet, (apiSuccess) => {
            // JUNTA OS VALORES RECEBIDOS
            registros = registros.concat(apiSuccess.data)

            // CHAMA A FUNÇÃO PARA BUSCAR OS PROXIMOS REGISTROS
            this.demEdiProTabOnBuscarCampoSeletor(callback, vetor, Number(apiSuccess.countAll), registros)
          }, (apiError) => {
            // SETA OS VALORES RECEBIDOS
            this.campoEditar[vetor.chave].status = apiError

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          })
        } else if (total === 0) {
          // SETA OS VALORES RECEBIDOS
          this.campoEditar[vetor.chave].onBuscarOptions = null

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        } else {
          // SETA OS VALORES RECEBIDOS
          this.campoEditar[vetor.chave].options = registros

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        }
      },
      demEdiProTabOnBuscarCasos: function (callback, vetor) {
        // MONTA O QUERY GET
        var queryGet = {
          p_doc_tp: this.cpntPDocTp,
          id_pro: vetor.linha.id_pro,
          ncm: vetor.linha.id_pro_ncm,
          id_con: this.cpntIdCon,
          id_p_pais: this.cpntIdConIdPais,
          id_uf: ([ '', null, undefined ].indexOf(this.cpntIdConUF) === -1 ? this.cpntIdConUF : this.$store.state.licenca.uf)
        }

        // SETA O NOME DA DEMANDA QUE DEVE BUSCAR
        switch (this.cpntDemanda) {
          case 'venda':
            queryGet.demanda = 'dem_venda'
            break
        
          case 'dev_cliente':
            queryGet.demanda = 'dem_dev_cliente'
            break

          case 'dev_fornecedor':
            queryGet.demanda = 'dem_dev_fornecedor'
            break

          case 'compra':
            queryGet.demanda = 'dem_compra'
            break
        }

        // CONVERTE O VALOR EM LOT
        queryGet = { lot: [ queryGet ] }

        // FAZ A BUSCA DOS DADOS
        this.$store.state.comunicaAPI('/produto/sit-fiscal2/simulador/get', 'POST', queryGet, (retorno) => {
          // PEGA OS VALORES RETORNADOS
          retorno = retorno.lot[0]

          // VERIFICA SE RECEBEU O RETORNO
          switch (retorno.code) {
            case '200':
              // VERIFICA SE O VALOR EXISTE, POIS A API NÃO RETORNA A CHAVE DATA QUANDO NÃO TEM REGISTRO
              if ([ '', null, undefined ].indexOf(retorno.data) !== -1) {
                retorno.data = []
              }

              // MONTA O NOME DO CASO QUE SERÁ MOSTRADO NO SELETOR
              for (var indexR in retorno.data) {
                // INICIA O NOME DO CASO
                retorno.data[indexR]._id_caso_nome = ''

                // VERIFICA SE TEM CASO SELECIONADO
                if ([ '', null, undefined ].indexOf(retorno.data[indexR].id_caso) === -1) {
                  // SETA O NOME DO CASO
                  retorno.data[indexR]._id_caso_nome = retorno.data[indexR].id_caso_nome

                  // SETA O ESTADO DO CASO
                  if ([ '', null, undefined, '0' ].indexOf(retorno.data[indexR].id_uf) === -1) {
                    retorno.data[indexR]._id_caso_nome += ' | UF: ' + retorno.data[indexR].id_uf
                  }

                  // SETA O CONTATO DO CASO
                  if ([ '', null, undefined, '0' ].indexOf(retorno.data[indexR].id_con_nome) === -1) {
                    retorno.data[indexR]._id_caso_nome += ' | Contato: ' + retorno.data[indexR].id_con_nome
                  }

                  // SETA O NCM DO CASO
                  if ([ '', null, undefined ].indexOf(retorno.data[indexR].ncm) === -1) {
                    retorno.data[indexR]._id_caso_nome += ' | NCM: ' + retorno.data[indexR].ncm
                  }

                  // SETA O CONTATO DO CASO
                  if ([ '', null, undefined, '0' ].indexOf(retorno.data[indexR].id_pro) === -1) {
                    retorno.data[indexR]._id_caso_nome += ' | Produto: ' + retorno.data[indexR].id_pro_nome
                  }

                  // SETA O NCM DO CASO
                  if ([ '', null, undefined ].indexOf(retorno.data[indexR].id_cfop) === -1) {
                    retorno.data[indexR]._id_caso_nome += ' | CFOP ' + retorno.data[indexR].id_cfop
                    // + ' - ' + retorno.data[indexR].id_cfop_descricao
                  }
                }
              }
    
              // SETA OS VALORES RECEBIDOS
              this.campoEditar[vetor.chave].options = retorno.data

              // VERIFICA SE TEM ALGUM VALOR NO VETOR
              if (retorno.data.length === 0) {
                // REMOVE A FUNÇÃO PARA NÃO ENTRAR EM LOOP INFINITO
                this.campoEditar[vetor.chave].onBuscarOptions = null

                // LIMPA O VALOR SELECIONADO POIS NÃO EXISTE MAIS
                this.campoEditar[vetor.chave].value = '__ADD__NOVO_OPTION__'

                // ABRE O FORMULARIO PARA CADASTRAR UM NOVA CONFIGURAÇÃO
                // this.campoEditar[vetor.chave].newOption()
              }
    
              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()
    
              // EXECUTA A FUNÇÃO CALLBACK
              callback()
              break
          
            default:
              // APRESENTA A MENSAGEM DE ERRO
              this.$store.state.TRATAR_RET_LOT_API(retorno)

              // SETA OS VALORES RECEBIDOS
              this.campoEditar[vetor.chave].onBuscarOptions = null

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()

              // EXECUTA A FUNÇÃO CALLBACK
              callback()
              break
          }

        }, (apiError) => {
          // SETA OS VALORES RECEBIDOS
          this.campoEditar[vetor.chave].status = apiError

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
        })
      },
      demEdiProTabOnBuscarCFOP: function (callback, vetor, total = null, registros = []) {
        if (total === null || total < registros.length) {
          // MONTA O QUERY GET
          var queryGet = { type: 'list', limit: { row: registros.length, qty: 1000 }, field: { cfop: null, descricao: null } }

          // // VERIFICA OS CFOP QUE DEVE BUSCAR
          // if ([ 'f', 'j' ].indexOf(this.cpntIdConPessoa) !== -1) {
          //   switch (this.cpntIdConUF === this.$store.state.licenca.uf) {
          //     case true:
          //       queryGet.where = { aAnd: [ { f: 'cfop', o: '>', v: '5000' }, { f: 'cfop', o: '<', v: '6000' } ] }
          //       break

          //     case false:
          //     default:
          //       queryGet.where = { aAnd: [ { f: 'cfop', o: '>', v: '6000' }, { f: 'cfop', o: '<', v: '7000' } ] }
          //       break
          //   }
          // } else {
          //   queryGet.where = { aAnd: [ { f: 'cfop', o: '>', v: '7000' }, { f: 'cfop', o: '<', v: '8000' } ] }
          // }
  
          // FAZ A BUSCA DOS DADOS
          this.$store.state.comunicaAPI('/referencia/pro-cfop/get/', 'GET', queryGet, (apiSuccess) => {
            // JUNTA OS VALORES RECEBIDOS
            registros = registros.concat(apiSuccess.data)

            // CHAMA A FUNÇÃO PARA BUSCAR OS PROXIMOS REGISTROS
            this.demEdiProTabOnBuscarCFOP(callback, vetor, Number(apiSuccess.countAll), registros)
          }, (apiError) => {
            // SETA OS VALORES RECEBIDOS
            this.campoEditar[vetor.chave].status = apiError

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          })
        } else if (total === 0) {
          // SETA OS VALORES RECEBIDOS
          this.campoEditar[vetor.chave].onBuscarOptions = null

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        } else {
          // SETA OS VALORES RECEBIDOS
          this.campoEditar[vetor.chave].options = registros

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        }
      },
      demEdiProTabOnBuscarOrigem: function (callback, vetor, total = null, registros = []) {
        if (total === null || total < registros.length) {
          // MONTA O QUERY GET
          var queryGet = { type: 'list', limit: { row: registros.length, qty: 1000 }, field: { ref_icms_origem_id: null, ref_icms_origem_desc: null } }
  
          // FAZ A BUSCA DOS DADOS
          this.$store.state.comunicaAPI('/referencia/pro-icms-origem/get/', 'GET', queryGet, (apiSuccess) => {
            // JUNTA OS VALORES RECEBIDOS
            registros = registros.concat(apiSuccess.data)

            // CHAMA A FUNÇÃO PARA BUSCAR OS PROXIMOS REGISTROS
            this.demEdiProTabOnBuscarOrigem(callback, vetor, Number(apiSuccess.countAll), registros)
          }, (apiError) => {
            // SETA OS VALORES RECEBIDOS
            this.campoEditar[vetor.chave].status = apiError

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          })
        } else if (total === 0) {
          // SETA OS VALORES RECEBIDOS
          this.campoEditar[vetor.chave].onBuscarOptions = null

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        } else {
          // SETA OS VALORES RECEBIDOS
          this.campoEditar[vetor.chave].options = registros

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        }
      },
      demEdiProTabOnBuscarIcmsModBcSt: function (callback, vetor, total = null, registros = []) {
        if (total === null || total < registros.length) {
          // MONTA O QUERY GET
          var queryGet = { type: 'list', limit: { row: registros.length, qty: 1000 } }
  
          // FAZ A BUSCA DOS DADOS
          this.$store.state.comunicaAPI('/referencia/pro-icms-mod-bc-st/get/', 'GET', queryGet, (apiSuccess) => {
            // JUNTA OS VALORES RECEBIDOS
            registros = registros.concat(apiSuccess.data)

            // CHAMA A FUNÇÃO PARA BUSCAR OS PROXIMOS REGISTROS
            this.demEdiProTabOnBuscarIcmsModBcSt(callback, vetor, Number(apiSuccess.countAll), registros)
          }, (apiError) => {
            // SETA OS VALORES RECEBIDOS
            this.campoEditar[vetor.chave].status = apiError

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          })
        } else {
          // SETA OS VALORES RECEBIDOS
          this.campoEditar[vetor.chave].options = registros.filter(item => item.ref_icms_mod_bc_st_id !== '-1')

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        }
      },
      demEdiProTabOnBuscarRedSobre: function (callback, vetor) {
        // FAZ A BUSCA DOS DADOS
        this.$store.state.comunicaAPI('/referencia/pro-icms-ret-sobre/get', 'GET', null, (apiSuccess) => {
          // SETA OS VALORES RECEBIDOS
          this.campoEditar[vetor.chave].options = apiSuccess.data

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        }, (apiError) => {
          // SETA OS VALORES RECEBIDOS
          this.campoEditar[vetor.chave].status = apiError

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
        })
      },
      demEdiProTabOnBuscarIcmsModBc: function (callback, vetor, total = null, registros = []) {
        if (total === null || total < registros.length) {
          // MONTA O QUERY GET
          var queryGet = { type: 'list', limit: { row: registros.length, qty: 1000 } }
  
          // FAZ A BUSCA DOS DADOS
          this.$store.state.comunicaAPI('/referencia/pro-icms-mod-bc/get/', 'GET', queryGet, (apiSuccess) => {
            // JUNTA OS VALORES RECEBIDOS
            registros = registros.concat(apiSuccess.data)

            // CHAMA A FUNÇÃO PARA BUSCAR OS PROXIMOS REGISTROS
            this.demEdiProTabOnBuscarIcmsModBc(callback, vetor, Number(apiSuccess.countAll), registros)
          }, (apiError) => {
            // SETA OS VALORES RECEBIDOS
            this.campoEditar[vetor.chave].status = apiError

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          })
        } else {
          // SETA OS VALORES RECEBIDOS
          this.campoEditar[vetor.chave].options = registros

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        }
      },
      demEdiProTabOnBuscarCstIcms: function (callback, vetor, total = null, registros = []) {
        if (total === null || total < registros.length) {
          // MONTA O QUERY GET
          var queryGet = { type: 'list', limit: { row: registros.length, qty: 1000 } }

          // SETA O WHERE QUE DEVE REALIZAR
          queryGet.where = { f: 'ref_icms_rt_id', o: '=', v: (this.$store.state.licenca.rt_id === '3' ? '3' : '1,2') }
  
          // FAZ A BUSCA DOS DADOS
          this.$store.state.comunicaAPI('/referencia/pro-icms-cst/get/', 'GET', queryGet, (apiSuccess) => {
            // JUNTA OS VALORES RECEBIDOS
            registros = registros.concat(apiSuccess.data)

            // CHAMA A FUNÇÃO PARA BUSCAR OS PROXIMOS REGISTROS
            this.demEdiProTabOnBuscarCstIcms(callback, vetor, Number(apiSuccess.countAll), registros)
          }, (apiError) => {
            // SETA OS VALORES RECEBIDOS
            this.campoEditar[vetor.chave].status = apiError

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          })
        } else if (total === 0) {
          // SETA OS VALORES RECEBIDOS
          this.campoEditar[vetor.chave].onBuscarOptions = null

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        } else {
          // SETA OS VALORES RECEBIDOS
          this.campoEditar[vetor.chave].options = registros

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        }
      },
      demEdiProTabOnBuscarCstIpi: function (callback, vetor, total = null, registros = []) {
        if (total === null || total < registros.length) {
          // MONTA O QUERY GET
          var queryGet = { type: 'list', limit: { row: registros.length, qty: 1000 } }
  
          // FAZ A BUSCA DOS DADOS
          this.$store.state.comunicaAPI('/referencia/pro-ipi-cst/get/', 'GET', queryGet, (apiSuccess) => {
            // JUNTA OS VALORES RECEBIDOS
            registros = registros.concat(apiSuccess.data)

            // CHAMA A FUNÇÃO PARA BUSCAR OS PROXIMOS REGISTROS
            this.demEdiProTabOnBuscarCstIpi(callback, vetor, Number(apiSuccess.countAll), registros)
          }, (apiError) => {
            // SETA OS VALORES RECEBIDOS
            this.campoEditar[vetor.chave].status = apiError

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          })
        } else if (total === 0) {
          // SETA OS VALORES RECEBIDOS
          this.campoEditar[vetor.chave].onBuscarOptions = null

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        } else {
          // SETA OS VALORES RECEBIDOS
          this.campoEditar[vetor.chave].options = registros

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        }
      },
      demEdiProTabOnBuscarCstIpiEnq: function (callback, vetor, total = null, registros = []) {
        if (total === null || total < registros.length) {
          // MONTA O QUERY GET
          var queryGet = { type: 'list', limit: { row: registros.length, qty: 1000 } }
  
          // FAZ A BUSCA DOS DADOS
          this.$store.state.comunicaAPI('/referencia/pro-ipi-enquadramento/get/', 'GET', queryGet, (apiSuccess) => {
            // JUNTA OS VALORES RECEBIDOS
            registros = registros.concat(apiSuccess.data)

            // CHAMA A FUNÇÃO PARA BUSCAR OS PROXIMOS REGISTROS
            this.demEdiProTabOnBuscarCstIpiEnq(callback, vetor, Number(apiSuccess.countAll), registros)
          }, (apiError) => {
            // SETA OS VALORES RECEBIDOS
            this.campoEditar[vetor.chave].status = apiError

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          })
        } else if (total === 0) {
          // SETA OS VALORES RECEBIDOS
          this.campoEditar[vetor.chave].onBuscarOptions = null

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        } else {
          // SETA OS VALORES RECEBIDOS
          this.campoEditar[vetor.chave].options = registros

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        }
      },
      demEdiProTabOnBuscarCstIpiSelo: function (callback, vetor, total = null, registros = []) {
        if (total === null || total < registros.length) {
          // MONTA O QUERY GET
          var queryGet = { type: 'list', limit: { row: registros.length, qty: 1000 } }
  
          // FAZ A BUSCA DOS DADOS
          this.$store.state.comunicaAPI('/referencia/pro-ipi-selo/get/', 'GET', queryGet, (apiSuccess) => {
            // JUNTA OS VALORES RECEBIDOS
            registros = registros.concat(apiSuccess.data)

            // CHAMA A FUNÇÃO PARA BUSCAR OS PROXIMOS REGISTROS
            this.demEdiProTabOnBuscarCstIpiSelo(callback, vetor, Number(apiSuccess.countAll), registros)
          }, (apiError) => {
            // SETA OS VALORES RECEBIDOS
            this.campoEditar[vetor.chave].status = apiError

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          })
        } else if (total === 0) {
          // SETA OS VALORES RECEBIDOS
          this.campoEditar[vetor.chave].onBuscarOptions = null

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        } else {
          // SETA OS VALORES RECEBIDOS
          this.campoEditar[vetor.chave].options = registros

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        }
      },
      demEdiProTabOnBuscarCstPisCofins: function (callback, vetor, total = null, registros = []) {
        if (total === null || total < registros.length) {
          // MONTA O QUERY GET
          var queryGet = { type: 'list', limit: { row: registros.length, qty: 1000 } }
  
          // FAZ A BUSCA DOS DADOS
          this.$store.state.comunicaAPI('/referencia/pro-pis-cof-cst/get/', 'GET', queryGet, (apiSuccess) => {
            // JUNTA OS VALORES RECEBIDOS
            registros = registros.concat(apiSuccess.data)

            // CHAMA A FUNÇÃO PARA BUSCAR OS PROXIMOS REGISTROS
            this.demEdiProTabOnBuscarCstPisCofins(callback, vetor, Number(apiSuccess.countAll), registros)
          }, (apiError) => {
            // SETA OS VALORES RECEBIDOS
            this.campoEditar[vetor.chave].status = apiError

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          })
        } else if (total === 0) {
          // SETA OS VALORES RECEBIDOS
          this.campoEditar[vetor.chave].onBuscarOptions = null

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        } else {
          // SETA OS VALORES RECEBIDOS
          this.campoEditar[vetor.chave].options = registros

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        }
      },
      demEdiProTabAbrirControleProcesso: function (linha) {
        // INICIA OS PARAMETROS
        var params = { acao: 'ABRIR_CADASTRO', id: linha.id, tipo: 'processo', modelo: 'produto' }
        
        // SETA O CALLBACK QUE DEVE EXECUTAR
        params.callback = (atualizar) => {
          if (atualizar === true) {
            this.demEdiProTabBuscarLinhas()
          }
        }

        // CHAMA A FUNÇÃO PARA ABRIR OS DADOS
        this.$store.commit('SET_ABRIR_CADASTRO', params)
      },
      demEdiProTabReinicializarSitFiscal: function (ids = []) {
        // REMOVE O FOCUS DE QUALQUER CAMPO
        if (document.activeElement !== document.body) {
          document.activeElement.blur()
        }

        // CHAMA A FUNÇÃO PARA DESTRAVAR A TELA
        this.$parent.$emit('DEMANDA_TRAVAR_TELA', true)

        // SETA O STATUS DO BOTÃO
        this.botaoReinicializar = 'carregando'

        // IMPORA A FUNÇÃO CALCULA A FOR DA LETRA
        const FUN_PEGAR_CHAVE_DEMANDA = require('@/assets/js/Funcoes-Gerais.js').FUN_PEGAR_CHAVE_DEMANDA

        // PEGA A CHAVE REFERENCIA
        var chaveD = FUN_PEGAR_CHAVE_DEMANDA(this.cpntDemanda)

        // INICIA A VARIAVEL QUE SERÁ ENVIADA
        var formData = { lot: [] }

        // PEGA TODAS AS LINHAS COM DIFERENÇAS
        for (var index in this.linha) {
          // INICIA A VARIAVEL DE VERIFICAR
          var atualizar = false

          // VERIFICA SE TEM QUE ATUALIZAR O CASO DO PRODUTO
          atualizar = atualizar === true ? atualizar : (ids.length === 0 && ([ '', null, undefined ].indexOf(this.linha[index].p_id_sf2) !== -1 || this.linha[index].p_id_sf2_status !== '1' || this.linha[index].virtual_check_caso.qtde >= 1))

          // VERIFICA SE TEM QUE ATUALIZAR O CASO DO PRODUTO
          atualizar = atualizar === true ? atualizar : (ids.indexOf(this.linha[index].id) !== -1)

          // VERIFICA SE DEVE ATUALIZAR O CADASTRO DO PRODUTO
          if (atualizar === true) {
            // INICIA O FORMULARIO QUE SERÁ APRESENTADO
            var vetor = {}

            // SETA O NUMERO DA DEMANDA
            vetor[chaveD] = this.cpntDemandaId

            // SETA O ID DA TABELA
            vetor.id = this.linha[index].id

            // SETA O ID DO CASO ATUAL
            vetor.id_pro_sf = this.linha[index].virtual_check_caso.caso_atual

            // ADICIONA A INFORMAÇÃO AO VETOR
            formData.lot.push(vetor)
          }
        }

        // VERIFICA SE TEM ALGUMA COISA PARA ATUALIZAR
        if (formData.lot.length <= 0)  {
          // ATUALIZA OS DADOS DA TABELA
          this.demEdiProTabBuscarLinhas()

          // DESTRAVA A TELA
          this.$parent.$emit('DEMANDA_TRAVAR_TELA', false)
        } else {
          // SETA O NOME DA ROTA
          var route = ''

          // VERIFICA A ROTA QUE DEVE CHAMAR
          switch (this.cpntDemanda) {
            case 'venda':
              route = '/venda/produto'
              break
          
            case 'dev_cliente':
              route = '/demanda/dem-dev-cliente/dem-produto'
              break

            case 'dev_fornecedor':
              route = '/demanda/dem-dev-fornecedor/dem-produto'
              break

            case 'compra':
              route = '/demanda/dem-compra/dem-produto'
              break
          }

          // CHAMA FUNÇÃO PARA COMUNICAR COM API
          this.$store.state.comunicaAPI(route, 'PUT', formData, (apiSuccess) => {
            // PEGA O RETORNO RECEBIDO 
            var retorno = apiSuccess.lot[0]
  
            // VERIFICA O RESULTADO DA OPERAÇÃO
            switch (retorno.code) {
              case '200':
                // ATUALIZA OS DADOS E DESTRAVA A TELA
                this.$parent.$emit('DEMANDA_BUSCAR_VALORES', () => {
                  // ATUALIZA OS DADOS DA TABELA
                  this.demEdiProTabBuscarLinhas()
  
                  // APRESENTA A MENSAGEM DE SUCESSO
                  this.$store.state.TRATAR_RET_LOT_API(apiSuccess)
  
                  // DESTRAVA A TELA
                  this.$parent.$emit('DEMANDA_TRAVAR_TELA', false)
                })
                break
  
              default:
                // ATUALIZA OS DADOS DA TABELA
                this.demEdiProTabBuscarLinhas()
  
                // FAZ A APRESENTAÇÃO DO ERRO NA TELA
                this.$store.state.FUN_API_RET_VALIDA(this, 'campos', retorno.message, retorno.code, {}, true, () => { this.$parent.$emit('DEMANDA_TRAVAR_TELA', false) })
                break
            }

            // SETA O STATUS DO BOTÃO
            this.botaoReinicializar = ''
          }, this.demEdiProTabSetarStatusGeral)
        }
      },
      demEdiProTabCopiarProduto: function () {
        // VERIFICA SE TEM PRODUTO SELECIONADO
        if (this.checkbox.length === 0) {
          this.$store.state.msgWarn('WEB [406]: Selecione ao menos um registro para prosseguir.', 'warning')
        } else {
          // SETA OS PARAMETROS QUE SERÁ ENVIADO
          var params = { tipo: 'CONSULTAR_DEMANDA', titulo: 'Copiar Venda', copiar: true }

          // SETA O CALLBACK QUE DEVE EXECUTAR
          params.callback = (atualizar, id) => {
            if (atualizar === true) {
              this.demEdiProTabFecharCopiarProduto(id)
            }
          }

          // CHAMA A FUNÇÃO PARA INFORMAR QUE A ROTA FOI ATUALIZADA
          this.$store.commit('SET_ABRIR_CADASTRO_VET', params)
        }
      },
      demEdiProTabFecharCopiarProduto: function (cod_venda) {
        // REMOVE O FOCUS DE QUALQUER CAMPO
        if (document.activeElement !== document.body) {
          document.activeElement.blur()
        }

        // CHAMA A FUNÇÃO PARA DESTRAVAR A TELA
        this.$parent.$emit('DEMANDA_TRAVAR_TELA', true)

        // SETA O BOTÃO CARREGANDO
        this.botaoCopiar = 'carregando'

        // INICIA A VARIAVEL QUE SERÁ ENVIADA PARA API
        var formData = []
        
        // MONTA O INSERT DE CADA PRODUTO
        for (var indexL in this.linha) {
          if (this.checkbox.indexOf(this.linha[indexL].id) !== -1) {
            // INICIA A VARIAVEL DO ITEM
            var item = {}
  
            // ADICIONA O CODIGO DA VENDA
            item.cod_venda = cod_venda
  
            // ADICIONA OS VALORES RECEBIDOS
            for (var indexC in this.linha[indexL]) {
              if ([ 'id_pro', 'qtde', 'id_pco_status' ].indexOf(indexC) !== -1) {
                item[indexC] = this.linha[indexL][indexC]
              } else if ([ 'valor_uni' ].indexOf(indexC) !== -1) {
                item[indexC + '_novo'] = this.linha[indexL][indexC]
              }
            }
  
            // ADICIONA O ITEM AO VETOR QUE SERÁ ENVIADO PARA API
            formData.push(item)
          }
        }

        // PEGA OS DADOS PARA INSERIR NA API
        formData = { lot: formData }

        // CHAMA FUNÇÃO PARA COMUNICAR COM API
        this.$store.state.comunicaAPI('/venda/produto', 'POST', formData, (apiSuccess) => {
          // PEGA O RETORNO RECEBIDO 
          var retorno = apiSuccess.lot[0]

          // MONTA A FUNÇÃO DE ATUALIZAÇÃO
          var finalizar = () => {
            // DESTRAVA A TELA
            this.$parent.$emit('DEMANDA_TRAVAR_TELA', false)

            // SETA O BOTÃO
            this.botaoCopiar = this.demEdiProTabCopiarProduto

            // VERIFICA SE É A MESMA VENDA, SE FOR ATUALIZA A TELA
            if (cod_venda === this.cpntDemandaId) {
              this.$parent.$emit('DEMANDA_BUSCAR_VALORES', () => { this.demEdiProTabBuscarLinhas() })
            }
          }

          // VERIFICA O RESULTADO DA OPERAÇÃO
          switch (retorno.code) {
            case '200':
              // APRESENTA A MENSAGEM DE SUCESSO
              this.$store.state.TRATAR_RET_LOT_API(apiSuccess)

              // CHAMA A FUNÇÃO PARA FINALIZAR O PROCESSO
              finalizar()
              break

            default:
              this.$store.state.FUN_API_RET_VALIDA(this, 'campos', retorno.message, retorno.code, {}, true, () => { finalizar() })
              break
          }
        }, this.demEdiProTabSetarStatusGeral)
      },
      demEdiProTabAcaoEditarCampo: function (event, indexL, chave) {
        // PROCURA O NOME DA COLUNA QUE DEVE EDITAR
        var indexC = this.$refs.tabela.colunas.findIndex(item => item.chave === chave)

        // MANDA ABRIR AS AÇÕES DA TELA
        this.$refs.tabela.cpntMostrarOcultarAcoesCelula(event, indexL, indexC, 'acoes')

        // AGUARDA O CARREGAMENTO PARA ABRIR O EDITAR
        setTimeout(() => { this.$refs.tabela.cpntMostrarOcultarAcoesCelula(event, indexL, indexC, 'editar') }, 100)
      },
      demEdiProTabAcaoTriangulo: function (indexCV, linha) {
        // OCULTA A LISTA DE DADOS
        this.demEdiProTabOcultarOpcoesSuspensas()

        // SETA O NOME DA ABA QUE DEVE ABRIR
        this.dialog = 'NOVO_OU_ALTERAR_SIT_FISCAL'

        // SETA OS VALORES RECEBIDOS
        this.sit_fiscal = { indexCV: indexCV, linha: linha }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      demEdiProTabAbrirSitFiscalEscolha: function (acao) {
        // SETA OS VALORES
        var linha = JSON.parse(JSON.stringify(this.sit_fiscal.linha))

        // VERIFICA A AÇÃO QUE DEVE REALIZAR
        switch (acao) {
          case 'NOVO':
            // SETA OS CAMPOS QUE DEVE ENVIAR PARA O FORMULARIO
            linha.virtual_check_caso.diff = {
              p_id_cfop: null,
              p_icms_orig: null,
              p_icms_cst: null,
              p_icms_bc_mod: null,
              p_icms_a: null,
              p_icms_bc_p_r: null,
              p_icms_bc_p_r_c: null,
              p_icms_st_bc_mod: null,
              p_icms_mva_p: null,
              p_icms_st_bc_rt: null,
              p_icms_st_rt: null,
              p_icms_st_a: null,
              p_icms_bc_st_p_r: null,
              p_icms_fcp_a: null,
              p_icms_fcp_st_a_cf: null,
              p_icms_fcp_st_r_bc: null,
              p_icms_fcp_st_a: null,
              p_icms_fcp_st_r_a: null,
              p_pis_cst: null,
              p_pis_a: null,
              p_cofins_cst: null,
              p_cofins_a: null,
              p_ipi_cst: null,
              p_ipi_a: null,
              p_ipi_enq: null,
              p_ipi_selo: null
            }

            // MANDA ABRIR O FORMULARIO
            this.demEdiProTabAbrirSitFiscal(this.sit_fiscal.indexCV, linha, 0)
            break
        
          case 'EDITAR':
            this.demEdiProTabAbrirSitFiscal(this.sit_fiscal.indexCV, linha)
            break

          case 'REINICIALIZAR':
            // CHAMA A FUNÇÃO PARA REINICIALIZAR
            this.demEdiProTabReinicializarSitFiscal(linha.id)

            // SETA O NOME DA ABA QUE DEVE ABRIR
            this.dialog = null

            // SETA OS VALORES RECEBIDOS
            this.sit_fiscal = null

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
            break
        }
      },
      demEdiProTabAbrirSitFiscal: function (indexCV, linha, id) {
        // VERIFICA SE DEVE SETAR O ID DO CAMPO
        if ([ '', null, undefined ].indexOf(id) !== -1) {
          id = linha.p_id_sf2
        }

        // INICIA O VALOR DO CAMPO QUE SERÁ ATUALIZADO
        var formData = {}

        // PEGA OS CAMPOS QUE DEVEM ATUALIZAR
        var campos = indexCV === 'caso' ? Object.keys(linha.virtual_check_caso.diff) : [ indexCV ]

        // RODA UM VETOR PROCURANDO OS CAMPOS
        for (var indexC in campos) {
          // PEGA O NOMCE DO CAMPO QUE DEVE ATUALIZAR
          var chave = campos[indexC]

          // REMOVE O VALOR DA CHAVE
          if (chave.substring(0, 2) === 'p_' && chave.indexOf('p_') !== -1) {
            chave = chave.replace('p_', '')
          }

          // VERIFICA O CAMPO QUE DEVE ATUALIZAR
          switch (chave) {
            case 'id_cfop':
              formData[chave] = {
                cfop: linha.p_id_cfop,
                descricao: linha.p_id_cfop_descricao,
                j_demanda: linha.p_id_cfop_j_demanda
              }
              break

            case 'icms_cst':
              formData[chave] = {
                ref_icms_cst: linha.p_icms_cst,
                ref_icms_cst_desc: linha.p_icms_cst_ref_icms_cst_desc,
                ref_icms_rt_id: linha.p_icms_cst_ref_icms_rt_id,
                ref_icms_aa: linha.p_icms_cst_ref_icms_aa,
                ref_icms_bc_mod: linha.p_icms_cst_ref_icms_bc_mod,
                ref_icms_a: linha.p_icms_cst_ref_icms_a,
                ref_icms_bc_p_r: linha.p_icms_cst_ref_icms_bc_p_r,
                ref_icms_bc_p_r_c: linha.p_icms_cst_ref_icms_bc_p_r_c,
                ref_icms_st_bc_mod: linha.p_icms_cst_ref_icms_st_bc_mod,
                ref_icms_st_a: linha.p_icms_cst_ref_icms_st_a,
                ref_icms_bc_st_p_r: linha.p_icms_cst_ref_icms_bc_st_p_r,
                ref_icms_st_bc_rt: linha.p_icms_cst_ref_icms_st_bc_rt,
                ref_icms_st_rt: linha.p_icms_cst_ref_icms_st_rt,
                ref_icms_mva_p: linha.p_icms_cst_ref_icms_mva_p,
                ref_icms_fcp_a: linha.p_icms_cst_ref_icms_fcp_a,
                ref_icms_fcp_st_a: linha.p_icms_cst_ref_icms_fcp_st_a,
                ref_icms_fcp_st_a_cf: linha.p_icms_cst_ref_icms_fcp_st_a_cf,
                ref_icms_fcp_st_r_a: linha.p_icms_cst_ref_icms_fcp_st_r_a,
                ref_icms_fcp_st_r_bc: linha.p_icms_cst_ref_icms_fcp_st_r_bc
              }
              break

            case 'icms_bc_mod':
              formData[chave] = {
                ref_icms_mod_bc_id: linha.p_icms_bc_mod,
                ref_icms_mod_bc_desc: linha.p_icms_bc_mod_ref_icms_mod_bc_desc
              }
              break

            case 'icms_st_bc_mod':
              formData[chave] = {
                ref_icms_mod_bc_st_id: linha.p_icms_st_bc_mod,
                ref_icms_mod_bc_st_desc: linha.p_icms_st_bc_mod_ref_icms_mod_bc_st_desc
              }
              break

            case 'icms_orig':
              formData[chave] = {
                ref_icms_origem_id: linha.p_icms_orig,
                ref_icms_origem_desc: linha.p_icms_orig_ref_icms_origem_desc
              }
              break

            case 'pis_cst':
              formData[chave] = { ref_pc_cst: linha.p_pis_cst, ref_pc_cst_desc: linha.p_pis_cst_ref_pc_cst_desc, ref_pc_a: linha.p_pis_cst_ref_pc_a, ref_pc_ope: linha.p_pis_cst_ref_pc_ope }
              break

            case 'cofins_cst':
              formData[chave] = { ref_pc_cst: linha.p_cofins_cst, ref_pc_cst_desc: linha.p_cofins_cst_ref_pc_cst_desc, ref_pc_a: linha.p_cofins_cst_ref_pc_a, ref_pc_ope: linha.p_cofins_cst_ref_pc_ope }
              break

            case 'icms_bc_r':
              formData.icms_bc_p_r = linha.p_icms_bc_p_r
              break

            case 'icms_bc_st_r':
              formData.icms_bc_st_p_r = linha.p_icms_bc_st_p_r
              break

            case 'icms_bc_r_c':
              formData.icms_bc_p_r_c = { id: linha.p_icms_bc_p_r_c, descricao: linha.virtual_p_icms_bc_p_r_c_desc }
              break

            case 'ipi_cst':
              formData.ipi_cst = {
                ref_ipi_cst: linha.p_ipi_cst,
                ref_ipi_cst_desc: linha.p_ipi_cst_ref_ipi_cst_desc,
                ref_ipi_ope: linha.p_ipi_cst_ref_ipi_ope,
                ref_ipi_a: linha.p_ipi_cst_ref_ipi_a,
                ref_ipi_enq: linha.p_ipi_cst_ref_ipi_enq,
                ref_ipi_selo: linha.p_ipi_cst_ref_ipi_selo
              }
              break

            case 'ipi_enq':
              formData.ipi_enq = { ref_ipi_enq: linha.p_ipi_enq, ref_ipi_enq_desc: linha.p_ipi_enq_ref_ipi_enq_desc }
              break

            case 'ipi_selo':
              formData.ipi_selo = { ref_ipi_selo: linha.p_ipi_selo, ref_ipi_cor: linha.p_ipi_selo_ref_ipi_cor, ref_ipi_tipo: linha.p_ipi_selo_ref_ipi_tipo }
              break

            default:
              formData[chave] = linha['p_' + chave]
              break
          }
        }

        // SETA O NOME DA ABA QUE DEVE ABRIR
        this.dialog = null

        // INICIA O VETOR QUE SERÁ ENVIADO
        var vetor = {
          id: id,
          dados: formData,
          fechar: (atualizar, sit_fiscal) => {
            // MANDA REINICIALIZAR OS DADOS DA SITUAÇÃO FISCAL
            if (id === 0 && atualizar === true) {
              // VERIFICA SE TEM ID PARA SETAR
              if ([ '', null, undefined ].indexOf(sit_fiscal) === -1) {
                // PEGA O NUMERO DA LINHA QUE DEVE ATUALIZAR
                var indexS = this.linha.findIndex(item => item.id === linha.id)

                // SETA O NOVO ID PARA REINICIALIZAR
                if (indexS !== -1) {
                  this.linha[indexS].virtual_check_caso.caso_atual = sit_fiscal
                }
              }

              // REINICIALIZA A SITUAÇÃO FISCAL
              this.demEdiProTabReinicializarSitFiscal(linha.id)
            } else if (atualizar === true) {
              this.demEdiProTabBuscarLinhas()
            }

            // MANDA FECHAR OS DADOS
            this.demEdiProTabFecharSitFiscal()
          }
        }

        // SETA AS NCMS QUE DEVE SETAR NO VETOR
        if ([ '2655' ].indexOf(this.$store.state.token.clu) !== -1) {
          vetor.id_pros = [ linha.id_pro ]
        } else if ([ '', null, undefined ].indexOf(linha.id_pro_ncm) === -1) {
          vetor.ncms = [ linha.id_pro_ncm ]
        }

        // SETA OS DADOS QUE DEVE EDITAR NA SITUAÇÃO FSICAL
        this.sit_fiscal = vetor

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // OCULTA A LISTA DE DADOS
        this.demEdiProTabOcultarOpcoesSuspensas()
      },
      demEdiProTabOcultarOpcoesSuspensas: function () {
        setTimeout(() => {
          // SETA A VARIAVEL PARA EDIÇÃO DOS CAMPOS DO CASO
          this.$refs.tabela.ocultar_dialog = true

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.$refs.tabela.time = new Date().getTime()
        }, 500)
      },
      demEdiProTabAbrirNovaSitFiscal: function (vetor) {
        // INICIA O VETOR
        var params = { 
          id: 0,
          fechar: (atualizar, sit_fiscal) => {
            if (atualizar === true) {
              this.demEdiProTabOnBuscarCasos(() => {
                // VERIFICA SE O CASO FOI CADASTRADO PARA O PRODUTO
                if (this.campoEditar[vetor.chave].options.length >= 1) {
                  // PEGA O NUMERO DA LINHA QUE DEVE ATUALIZAR
                  var indexS = [ '', null, undefined ].indexOf(sit_fiscal) === -1 ? this.campoEditar[vetor.chave].options.findIndex(item => item.id === sit_fiscal) : 0

                  // SETA OS VALORES RECEBIDOS
                  this.campoEditar[vetor.chave].value = this.campoEditar[vetor.chave].options[indexS]

                  // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                  this.time = new Date().getTime()

                  // MANDA SALVAR A CONFIGURAÇÃO REALIZADA
                  this.demEdiProTabEditar()
                } else {                
                  // FECHA O FORMULARIO DE EDITAR
                  this.demEdiProTabEditarCancela()

                  // MANDA ATUALIZAR A TABELA
                  this.demEdiProTabBuscarLinhas()
                }

                // LIMPA O CAMPO PARA CHEGAR A JANELA
                this.demEdiProTabFecharSitFiscal()
              }, vetor)
            } else {
              this.demEdiProTabFecharSitFiscal()
            }
          }
        }

        // SETA AS NCMS QUE DEVE SETAR NO VETOR
        if ([ '2655' ].indexOf(this.$store.state.token.clu) !== -1) {
          params.id_pros = [ vetor.linha.id_pro ]
        } else if ([ '', null, undefined ].indexOf(vetor.linha.id_pro_ncm) === -1) {
          params.ncms = [ vetor.linha.id_pro_ncm ]
        }

        // SETA OS DADOS QUE DEVE EDITAR NA SITUAÇÃO FSICAL
        this.sit_fiscal = params

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // OCULTA A LISTA DE DADOS
        this.demEdiProTabOcultarOpcoesSuspensas()
      },
      demEdiProTabGerarCusto: function () {
        // SETA A VARIAVEL DO CUSTO
        this.custo = true

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // INICIA CARREGAMENTO
        this.demEdiProTabBuscarLinhas()
      },
      demEdiProTabFecharSitFiscal: function () {
        // LIMPA O CAMPO PARA CHEGAR A JANELA
        this.sit_fiscal = null

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      demEdiProTabAbrirHistorico: function (id) {
        // SETA OS PARAMETROS QUE SERÁ ENVIADO
        var params = { tipo: 'CONSULTAR_HISTORICO', filtros: { dem: [ 'dem_compra', 'dem_venda' ], dem_sta: [ 'dem_compra__2', 'dem_venda__2' ] } }

        // VERIFICA A DEMANDA QUE DEVE SELECIONAR
        params.filtros.dem = [ 'dem_compra', 'dem_venda' ]
        if ([ '1' ].indexOf(this.cpntIdConTpCon) !== -1) {
          params.filtros.dem = [ 'dem_venda' ]
        } else if ([ '2' ].indexOf(this.cpntIdConTpCon) !== -1) {
          params.filtros.dem = [ 'dem_compra' ]
        }

        // SETA QUE NÃO DEVE MOSTRAR SERVIÇOS
        params.filtros.ser = '__NENHUM__'

        // VERIFICA SE TEM ALGUM CADASTRO PRA FILTAR
        if ([ '', null, undefined, '0' ].indexOf(this.cpntIdVei) === -1) {
          params.filtros.vei = [ this.cpntIdVei.toString() ]
        }
        if ([ '', null, undefined, '0' ].indexOf(this.cpntIdPet) === -1) {
          params.filtros.pet = [ this.cpntIdPet.toString() ]
        }

        // SETA O CONTATO DESEJADO
        params.filtros.con = [ this.cpntIdCon.toString() ]

        // SETA O CONTATO DESEJADO
        params.filtros.pro = [ id.toString() ]

        // SETA O CALLBACK QUE DEVE EXECUTAR
        params.callback = (atualizar, id) => {
          if (atualizar === true) {
            this.demEditarCabAtualizarDados(params._chave, id)
          }
        }

        // CHAMA A FUNÇÃO PARA INFORMAR QUE A ROTA FOI ATUALIZADA
        this.$store.commit('SET_ABRIR_CADASTRO_VET', params)
      },
      demEdiProTabAbrirAlteracaoProcesso: function () {
        if ([ '', null, undefined ].indexOf(this.pco_status) !== -1) {
          this.$store.state.msgWarn('WEB [400]: Não é possivel editar em massa os status de processo, pois existem lista de status diferentes entre os itens.<br/><br/>Por favor, realize a edição individualmente.', 'warning')
        } else if (this.linha.length === 1) {
          this.demEdiProTabAbrirControleProcesso(this.linha[0])
        } else {
          // INICIA A VARIAVEL
          var vetor = []
  
          // PEGA OS VALORES
          for (var indexI in this.linha) {
            if ([ '', null, undefined ].indexOf(this.linha[indexI].id_pco_item) === -1) {
              vetor.push(this.linha[indexI].id)
            }
          }
  
          // INICIA A VARIAVEL
          this.pco_editar = vetor
  
          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
        }
      },
      demEdiProTabFecharAlteracaoProcesso: function (atualizar) {
        // LIMPA O CAMPO PARA CHEGAR A JANELA
        this.pco_editar = null

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // VERIFICA SE DEVE ATUALIZAR A TABELA
        if (atualizar === true) {
          this.demEdiProTabBuscarLinhas()
        }
      },
      demEdiProTabAbrirEtiqueta: function () {
        // INICIA A VARIAVEL
        var params = {}

        // VERIFICA SE ESTÁ NO MODELO NOVO
        if (this.$store.state.etiAntiga === true) {
          // INICIA OS PARAMETROS
          params = { tipo: 'COM_PRO_ABRIR_ETIQUETA', demanda: this.cpntDemanda, demandaId: this.cpntDemandaId }
  
          // CHAMA A FUNÇÃO PARA ABRIR OS DADOS
          this.$store.commit('SET_ABRIR_CADASTRO', params)
        } else {
          // INICIA OS PARAMETROS
          params = { tipo: 'GERAR_ETIQUETA', model: 'dem_compra_dem_produto' }

          // INICIA O VETOR
          params.ids = []

          // RODA O VETOR INSERIDO OS ITENS PARA ETIQUETAS
          for (var indexI in this.linha) {
            params.ids.push(this.linha[indexI].id)
          }

          // CHAMA A FUNÇÃO PARA ABRIR OS DADOS
          this.$store.commit('SET_ABRIR_CADASTRO', params)
        }
      },
      proFabTabSetarRelatorioConsumo: function (consumo) {
        // SETA O STATUS DA TELA
        this.consumo = consumo

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      }
      // proFabTabSetarRelatorioConsumo: function (consumo) {
      //   // SETA O STATUS DA TELA
      //   this.consumo = consumo

      //   // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
      //   this.time = new Date().getTime()
      // }
    },
    computed: {
      demEdiProTabValorLiquidoProduto: function () {
        return this.$store.state.FUN_MASK_VALOR('valorMoeda', (Number(this.cpntDemandaTotal.produto.liquido) + Number(this.cpntDemandaTotal.produto.creDevolucao)).toString())
      }
    },
    watch: {
      cpntPDocNFEmitida: function () {
        this.demEdiProTabMostrarBotaoEditar()
        this.demEdiProTabMostrarBotaoExcluir()
      },
      cpntFinStatus: function () {
        this.demEdiProTabMostrarBotaoEditar()
        this.demEdiProTabMostrarBotaoExcluir()
      },
      cpntPDocTp: function () {
        this.demEdiProTabBuscarLinhas()
      }
    }
  }
</script>
